import React, { useContext, useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  isStaleCartError,
  clearStaleCartStorage,
  showStaleCartDialog,
} from "../../../../utils/staleCartHandler";
import { getStoreCurrencySymbol } from "../../../../utils/currency";
import { createPortal } from "react-dom";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "App";
import { decreaseItemThroughScanner } from "config/Services";
import "./Cart.css";
import {
  applyOrderLevelDiscount,
  cartOfferCalculate,
  completePayment,
  complimentaryCart,
  CreateRestaurantOrder,
  dataRetriveWhenPageRefresh,
  deleteWholeCart,
  fetchTableBookingStatus,
  flushCart,
  getOrderDetails,
  getPaymentStatus,
  getToken,
  manualTableCancellation,
  orderCancelRequest,
  orderMetricsCreate,
  orderStatusRetry,
  payOrderSplit,
  repeatOrder,
  restaurantCartClose,
  restaurantCartUpdate,
  restaurantCreateCart,
  sendToKDS,
  updateProductQuantityOnCart,
  validateManagerPin,
} from "../../../../config/Services";
import CartItem from "./components/CartItem";
import Typography from "@mui/material/Typography";
import HoldCartModal from "./components/HoldCartModal/HoldCartModal";
import HoldOrderDrawer from "../../posnavbar/components/HoldOrderDrawer";
import { Box, Button, Card, CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import {
  addtoggleMode,
  searchTextRespaymnet,
  setAmtFocus,
} from "./redux/Actions/paginationActions";
import useGetDevice from "../hooks/useGetDevice";
import { useSelector } from "react-redux";
import { getMobilePos } from "./redux/Reducers/paginationReducer";
import { addcoupon } from "./redux/Actions/couponActions";
import { useSnackbar } from "../hooks/SnackbarProvider";
import { useAddToCart } from "../hooks/useAddToCart";
import { eventTracker } from "../../../common/event-tracker/eventTracker";
import { eventTrackerConstant } from "../../../common/event-tracker/event-tracker-constants";
import {
  getEventTimeDetails,
  getFullState,
  getManuallyAddedGtinArray,
  getManuallyAddedProduct,
  getManuallyRemovedItems,
  getProductTimeArray,
  getScannedProduct,
  getTotalProducts,
} from "./redux/Reducers/eventTrackerReducer";
import {
  changePrevAddedTime,
  eventTrackerTime,
  resetState,
  resetStateWithoutTime,
} from "./redux/Actions/eventTracker";
import useAuthModal from "../hooks/useAuthModal";
import { CartCustomerDetails } from "./CartAddCustomer/CartCustomerDetails";
import { GiftIcon } from "@heroicons/react/24/outline";
import cashNew from "../../../../assets/images/cash-new.png";
import cashNewSelected from "../../../../assets/images/cash-new-selected.png";
import cardNew from "../../../../assets/images/card-new.png";
import cardNewSelected from "../../../../assets/images/card-new-selected.png";
import upiNew from "../../../../assets/images/upi-new.png";
import upiNewSelected from "../../../../assets/images/upi-new-selected.png";
import splitNew from "../../../../assets/images/split-new.png";
import splitNewSelected from "../../../../assets/images/split-new-selected.png";
import creditNew from "../../../../assets/images/credit-new.png";
import creditNewSelected from "../../../../assets/images/credit-new-selected.png";
import ManagerAuthModal from "../all-products/components/twoWaykeyboardPaymentPage/components/managerAuth/index";
import { customEventTrigger } from "../../../../analytics";
import { getManager, getsessionPin } from "./redux/Reducers/sessionReducer";
import offlineImg from "../../../../assets/images/offline-icon.png";
import usePrint from "../hooks/usePrint";
import { getFromLocalStorage } from "../../../../utils/localStorageHelpers";
import { setHoldOrdersCount } from "./redux/Actions/holdOrdersCountActions";
import CouponPopup from "./components/twoWaykeyboardPaymentPage/components/coupons-popup";
import { getCouponState } from "./redux/Reducers/couponReducer";
import CouponUI from "./components/twoWaykeyboardPaymentPage/components/coupons-popup/appliedCoupon";
import LoyaltyPopupCustom from "./components/twoWaykeyboardPaymentPage/components/loyalty-popup";
import LoyaltyAppliedUI from "./components/twoWaykeyboardPaymentPage/components/loyalty-popup/appliedLoyalty";
import { OfferListing } from "./components/twoWaykeyboardPaymentPage/components/offerListing";
import { debounce } from "lodash";
import { OfferCheckModal } from "./components/twoWaykeyboardPaymentPage/components/offerCheckModal";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Swal from "sweetalert2";
import { DeliveryModal } from "./components/twoWaykeyboardPaymentPage/components/deliveryModal";
import ConfettiExplosion from "react-confetti-explosion";
import ReleaseTableDrawer from "../../table-layout/components/ReleaseTableDrawer/ReleaseTableDrawer";
import DiscountDrawer from "./components/DiscountDrawer/DiscountDrawer";
import AppliedDiscountCard from "./components/DiscountDrawer/AppliedDiscountCard";
import CartAggsLayout from "../../../../customComponents/CartAggsLayout/CartAggsLayout";
import PaymentModal from "./components/twoWaykeyboardPaymentPage/components/paymentModal";
import ComplimentaryProductList from "./components/ComplimentaryProductList/ComplimentaryProductList";
import { usePrinterAgentStatus } from "../../../../context/PrinterAgentContext";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/20/solid";
import AllKotsModal from "./components/AllKotsModal/AllKotsModal";
import { getPlacedKotGroups } from "./components/AllKotsModal/kotGroups";
import CartRightSidebar from "./components/CartRightSidebar/CartRightSidebar";
import FineDineActionButtons from "./components/FineDineActionButtons/FineDineActionButtons";
import TransferTableModal from "./components/TransferTableModal/TransferTableModal";
import { PosCustomButton } from "../../../../customComponents/PosCustomButton/PosCustomButton";
import useLoyaltyCouponConfig from "../../../../hooks/useLoyaltyCouponConfig";
import { applyRoundOff } from "./utils/cartUtils";
import PosCustomIcon from "../../../../customComponents/PosCustomIcon/PosCustomIcon";

export function Cart({
  openCustomerDetailTrigger,
  displayCgst,
  displaySgst,
  setCouponApplied,
  complimentaryMode,
  setComplimentaryMode,
  onAddProductClick,
}) {
  const { renderAuthModal, openAuthModal } = useAuthModal();
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { addItemDirect } = useAddToCart();
  const navigate = useNavigate();

  const {
    cartItems,
    setCartItems,
    cartId,
    setCartId,
    setSubTotal,
    totalTaxes,
    setTotalTaxes,
    total,
    setTotal,
    setTotalValue,
    setCgst,
    setSgst,
    setCess,
    subTotal,
    paymentMethod,
    setPaymentMethod,
    offerFound,
    highlightedCartProductId,
    setHighlightedCartProductId,
    setCartRefetch,
    setCartGrossBarVisible,
    color,
    setCouponApplied: setContextCouponApplied,
    animationBox,
    setanimationBox,
    setCartTotalQty,
    setOfferFound,
    gtinItem,
    setItemgtin,
    highlightMrp,
    setHighlightMrp,
    setIsLoadingScreen,
  } = useContext(UserContext);

  // State declarations - moved to top to fix the reference error

  const [increaseCartItemLoader, setIncreaseCartItemLoader] = useState(null);
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [hasRequestedForNewItem, setHasRequestedForNewItem] = useState(false);
  const [isBillPrinted, setIsBillPrinted] = useState(false);
  const [printedBillOrderId, setPrintedBillOrderId] = useState(null);
  const [printBillLoader, setPrintBillLoader] = useState(false);
  const [lastPlacedSequence, setLastPlacedSequence] = useState(null);
  const [showFineDineActionButtons, setShowFineDineActionButtons] = useState(false);
  const forceRoundOffEnabled = true; // Always enable rounding

  const isMobilePos = useSelector(getMobilePos);
  const mode = localStorage.getItem("mode");
  const locId = localStorage.getItem("locId");
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [showText, setShowText] = useState(false);
  const details = localStorage.getItem("retailUserDetails");
  const retailUserDetails = details ? JSON.parse(localStorage.getItem("retailUserDetails")) : {};
  const uidx = retailUserDetails?.uidx;
  const retailUserName = retailUserDetails?.firstName + " " + retailUserDetails?.secondName;
  const location = useLocation();
  const [openOffer, setOpenOffer] = useState(false);
  const storeMode = localStorage.getItem("storeMode");
  const machinenewId = localStorage.getItem("machineId");
  const [offerCheckList, setOfferCheckList] = useState([]);
  const orderMetricDataFullState = useSelector(getFullState);
  const retailType = localStorage.getItem("retailType");
  const branchSubType = localStorage.getItem("branchSubType");
  const [openCartCustomerDetail, setOpenCartCustomerDetail] = useState(() => {
    if (retailType === "RESTAURANT" && branchSubType === "FINE_DINE") {
      return false;
    }
    // Open the customer panel only when there's no active cart yet
    return localStorage.getItem("CartId") ? false : true;
  });

  const [isExploding, setIsExploding] = useState(false);
  const [comments, setComments] = useState("");

  const [managerModal, setmanagerModal] = useState(false);
  const { setSaleMode, saleMode } = useContext(UserContext);
  const { selectedTable, setSelectedTable } = useContext(UserContext);
  const { setTableSelectionModalOpen } = useContext(UserContext);
  const [newLoader, setNewLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [open, setOpen] = useState(localStorage.getItem("CartId") ? false : true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [amtToBePaid, setAmtToBePaid] = useState("");
  const [amtHeading, setAmtHeading] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [pAMt, setPAmt] = useState("");
  const [enterAmount, setEnterAmount] = useState("");
  const [loyaltyModal, setLoyaltyModal] = useState(false);
  const [couponsModal, setCouponsModal] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [holdCartModalOpen, setHoldCartModalOpen] = useState(false);
  const [holdOrderDrawerOpen, setHoldOrderDrawerOpen] = useState(false);
  const [lastAddedTime, setLastAddedTime] = useState(null);
  const [isSalesOrder, setIsSalesOrder] = useState(
    () => localStorage.getItem("cartOrderType") === "SALES_ORDER"
  );
  // Re-sync whenever the customer modal closes — both GST paths close it on success
  // after writing cartOrderType to localStorage, so this picks up the new value.
  useEffect(() => {
    if (!openCartCustomerDetail) {
      const nowSalesOrder = localStorage.getItem("cartOrderType") === "SALES_ORDER";
      setIsSalesOrder(nowSalesOrder);
      if (nowSalesOrder) {
        // Switching retail → B2B: the new Sales Order cart is empty so any
        // retail coupon / loyalty / discount rows must be cleared immediately.
        setShowCoupon(false);
        setShowLoyalty(false);
        setAppliedDiscountAmt(0);
        setAppliedDiscountType("NONE");
        dispatch(addcoupon(null));
        localStorage.removeItem("cartCoupon");
        localStorage.removeItem("loyaltyPoints");
        localStorage.removeItem("loyaltyDetails");
      }
    }
  }, [openCartCustomerDetail]); // eslint-disable-line react-hooks/exhaustive-deps
  const prevCartLengthRef = useRef(0);
  const [couponsData, setcouponsData] = useState([]);
  const [loader, setLoader] = useState({
    DINE_IN: false,
    TAKE_AWAY: false,
    DELIVERY: false,
  });
  const [paymentSuccessfulLoader, setPaymentSuccessfulLoader] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [adjustCheck, setAdjustCheck] = useState(false);
  const printerData = localStorage.getItem("printerConfig");
  const [printerConfig, setPrinterConfig] = useState(
    printerData ? JSON.parse(localStorage.getItem("printerConfig")) : null
  );
  const [partialStatus, setPartailStatus] = useState(false);
  const [splitActive, setSplitActive] = useState(false);
  const [paymentLoader, setpaymentLoader] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentLoadingModal, setPaymentLoadingModal] = useState(false);
  const [newId, setNewId] = useState("");
  const [paymentCancel, setPaymentCancel] = useState(false);
  const [amountPaid, setAmountPaid] = useState("0");
  const [amountDue, setAmountDue] = useState("0");
  const [checkOrderSatatus, setOrderStatus] = useState(false);
  const [openPayModal, setOpenPayModal] = useState(false);
  const [singleOrderoffline, setSingleOrderOffline] = useState(false);
  const [newTransId, setNewTransId] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [offerModal, setOfferModal] = useState(false);
  const [previousAmountPaid, setPreviousAmountPaid] = useState("");
  const [loaderAdj, setLoaderAdj] = useState(false);
  const [manual, setManaul] = useState(false);
  const cashierPin = useSelector(getsessionPin);
  const [approveloader, setApproveLoader] = useState(false);
  const [transCode, setTransCode] = useState("");
  const [cancelLoader, setCancelLoader] = useState(false);
  const [functionCalled, setFunctionCalled] = useState(false);
  const [cardFunctionCalled, setCardFunctionCalled] = useState(false);
  const [splitFunctionCalled, setSplitFunctionCalled] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [payLoader, setPayLoader] = useState(false);
  const [cashChange, setCashChange] = useState(false);
  const [cancelTrans, setCancelTarsn] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [cartActive, setCartActive] = useState(false);
  const [offerLoader, setOfferLoader] = useState(false);
  const [isPlacingDelivery, setIsPlacingDelivery] = useState(false);
  const [offerCheckModal, setOfferCheckModal] = useState(false);
  const [offerListData, setOfferListData] = useState(false);
  const [couponText, setCouponText] = useState("");
  const [customerLoader, setCustomerLoader] = useState(false);
  const [slotDetails, setSlotDetails] = useState(() => {
    try {
      const stored = localStorage.getItem("slotDetails");
      return stored ? JSON.parse(stored) : { slotId: "", cutoffId: "", startTime: "", endTime: "" };
    } catch (e) {
      return { slotId: "", cutoffId: "", startTime: "", endTime: "" };
    }
  });

  const cartListRef = useRef(null);
  const dualScreenChannel = useRef(null);
  const dualScreenLastPayload = useRef(null); // replayed when secondary window joins late
  const [showScrollArrow, setShowScrollArrow] = useState(false);

  const handleScroll = useCallback(() => {
    if (cartListRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = cartListRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      setShowScrollArrow(scrollHeight > clientHeight && !isAtBottom);
    }
  }, []);

  const handleScrollDown = useCallback(() => {
    if (cartListRef.current) {
      cartListRef.current.scrollTo({
        top: cartListRef.current.scrollTop + 150,
        behavior: "smooth",
      });
    }
  }, []);

  useEffect(() => {
    handleScroll();
    const timer = setTimeout(handleScroll, 100);
    window.addEventListener("resize", handleScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleScroll);
    };
  }, [cartItems, handleScroll]);

  useEffect(() => {
    if (slotDetails?.slotId) {
      localStorage.setItem("slotDetails", JSON.stringify(slotDetails));
    } else {
      localStorage.removeItem("slotDetails");
    }
  }, [slotDetails]);
  const enterAmountRef = useRef(null);
  const lastResetCartIdRef = useRef(null);
  const syncCartDiscountStateRef = useRef(null);
  const saleModeSeqRef = useRef(0);
  const loyaltyPoints = getFromLocalStorage("loyaltyPoints");
  const couponData = useSelector(getCouponState);

  const couponLocalStorageData =
    localStorage.getItem("cartCoupon") !== "undefined" &&
    localStorage.getItem("cartCoupon") !== null &&
    localStorage.getItem("cartCoupon")
      ? JSON.parse(localStorage.getItem("cartCoupon"))
      : null;
  const [showCoupon, setShowCoupon] = useState(couponLocalStorageData?.couponValue ? true : false);
  const [showLoyalty, setShowLoyalty] = useState(loyaltyPoints ? true : false);
  const [showOfferApplied, setShowOfferApplied] = useState(false);
  const mobileNumber = retailUserDetails?.mobileNumber;

  //local storage
  const orgId = localStorage.getItem("orgId");
  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const sessionlocId = localStorage.getItem("locId");
  const daySessionId = localStorage.getItem("daySessionId");
  const CartId = localStorage.getItem("CartId");
  const [openDelivery, setOpenDelivery] = useState(false);
  const licenseName = getFromLocalStorage("licenseName");
  const [showOffer, setShowOffer] = useState(false);
  const appConfigData = localStorage.getItem("appConfig");
  const appConfig = appConfigData ? JSON.parse(localStorage.getItem("appConfig")) : {};
  const creationOfMenuEnabled = appConfig?.all?.CREATION_OF_MENU?.flag === true;
  const roundOffEnabled = appConfig?.enabledFeatures?.ROUND_OFF;
  const roundOffCeilValue = appConfig?.settings?.ROUND_OFF?.roundOffCeil;
  const roundOffFloorValue = appConfig?.settings?.ROUND_OFF?.roundOffFloor;
  const customer_data = localStorage.getItem("customer_details");
  const holdOrdersCount = useSelector((state) => state.holdOrdersCount.count);
  const failedImgWarning = "https://icon-library.net/images/failed-icon/failed-icon-8.jpg";
  const cancelGif =
    "https://cdn0.iconfinder.com/data/icons/banking-156/60/cancel__delete__payment__card__credit-512.png";

  //event 0rdermetrics values
  const eventTime = useSelector(getEventTimeDetails);
  const productTimeArray = useSelector(getProductTimeArray);
  const totalProducts = useSelector(getTotalProducts);
  const manuallyAddedProducts = useSelector(getManuallyAddedProduct);
  const scannedProducts = useSelector(getScannedProduct);
  const manuallyRemovedItems = useSelector(getManuallyRemovedItems);
  const manuallyAddedGtinArray = useSelector(getManuallyAddedGtinArray);
  const selectedManager = useSelector(getManager);
  const selectedManagerRef = useRef(selectedManager);
  const { startPrint, isPrinting, openDrawer, connectPrinter, isError, printToken } = usePrint();
  const dispatch = useDispatch();
  const debounceTimeout = useRef(null);
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  const firstName = retailUserDetails?.firstName;
  const [canceledOnce, setCancelledOnce] = useState(false);
  const [disableProceed, setDisableProceed] = useState(false);
  const [deliveryCharge, setDeliveryCharge] = useState(() => {
    try {
      const mode = localStorage.getItem("fineDineSaleMode");
      if (mode === "DELIVERY" || mode === "TAKE_AWAY") {
        const stored = JSON.parse(localStorage.getItem("customer_details") || "{}");
        if (stored?.deliveryCharge != null) return stored?.deliveryCharge;
      }
    } catch {}
    return "";
  });
  const [packingCharge, setPackingCharge] = useState(() => {
    try {
      const mode = localStorage.getItem("fineDineSaleMode");
      if (mode === "DELIVERY" || mode === "TAKE_AWAY") {
        const stored = JSON.parse(localStorage.getItem("customer_details") || "{}");
        if (stored?.packingCharge != null) return stored?.packingCharge;
      }
    } catch {}
    return "";
  });
  const [appliedDiscountAmt, setAppliedDiscountAmt] = useState(0);
  const [appliedDiscountType, setAppliedDiscountType] = useState("NONE");
  const [discountApplyLoader, setDiscountApplyLoader] = useState(false);
  const [reservationDetails, setReservationDetails] = useState();
  const [placeOrderLoader, setPlaceOrderLoader] = useState(false);

  const paymentOrderSummary = useMemo(() => {
    return {
      // Keep values exactly as rendered on cart summary UI.
      grossTotalDisplay: total || 0,
      itemTotalDisplay: subTotal || 0,
      gstAndOtherChargesDisplay: totalTaxes || 0,
      discountDisplay: appliedDiscountAmt || 0,
      cgstDisplay: displayCgst || 0,
      sgstDisplay: displaySgst || 0,
      couponDisplay: couponData?.couponValue || 0,
      loyaltyDisplay: loyaltyPoints || 0,
      deliveryChargesDisplay: Number(deliveryCharge) || 0,
      packingChargesDisplay: Number(packingCharge) || 0,
    };
  }, [
    subTotal,
    totalTaxes,
    total,
    appliedDiscountAmt,
    displayCgst,
    displaySgst,
    couponData?.couponValue,
    loyaltyPoints,
    deliveryCharge,
    packingCharge,
  ]);
  const [tableBookingStatus, setTableBookingStatus] = useState([]);
  const [tableReleaseLoader, setTableReleaseLoader] = useState(false);
  const [accordionStates, setAccordionStates] = useState([]);
  const [tableConfirmationModalOpen, setTableConfirmationModalOpen] = useState(false);
  const [allKotsModalOpen, setAllKotsModalOpen] = useState(false);
  const [transferTableModalOpen, setTransferTableModalOpen] = useState(false);
  const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false);
  const [isOn, setIsOn] = useState(false);
  const [noteFromCustLoader, setNoteFromCustLoader] = useState(false);
  const [packingChargesLoader, setPackingChargesLoader] = useState(false);
  const [deliveryChargesLoader, setDeliveryChargesLoader] = useState(false);
  const [complimentaryProductList, setComplimentaryProductList] = useState([]);
  const [selectedComplimentaryIds, setSelectedComplimentaryIds] = useState([]);
  const [complimentaryProductPayload, setComplimentaryProductPayload] = useState({});
  const [complementaryButtonLoader, setComplementaryButtonLoader] = useState(false);
  const [markWholeCartComplimentary, setmarkWholeCartComplimentary] = useState(false);
  const [cartStatus, setCartStatus] = useState(null);
  const [showCartOptions, setShowCartOptions] = useState(false);
  const [focusedCartItemIndex, setFocusedCartItemIndex] = useState(-1);
  const isKDSRequired =
    appConfig?.settings?.DISPLAY_SYSTEM_MODE?.kdsDisplayScreens?.includes("KDS");

  const ODS_ORDER_AUTO_BUMPING =
    appConfig?.all?.ODS_ORDER_AUTO_BUMPING?.storeConfigSettings?.orderBumpingMode;

  const orderBumpingMode = appConfig?.settings?.ORDER_BUMPING_MODE?.orderBumpingMode;

  // Derive "ALWAYS" | "ASK" | "NEVER" from appConfig KOT_PRINT_MODE / BILL_PRINT_MODE settings
  const defaultPrintMode = branchSubType === "QSR" ? "ALWAYS" : "ASK";

  const kotSettings = appConfig?.settings?.KOT_PRINT_MODE?.settings || {};
  const kotPrintMode =
    kotSettings?.ASK === "enable"
      ? "ASK"
      : kotSettings?.ALWAYS === "enable"
      ? "ALWAYS"
      : kotSettings?.NEVER === "enable"
      ? "NEVER"
      : defaultPrintMode;

  const billSettings = appConfig?.settings?.BILL_PRINT_MODE?.settings || {};
  const billPrintMode =
    billSettings?.ASK === "enable"
      ? "ASK"
      : billSettings?.ALWAYS === "enable"
      ? "ALWAYS"
      : billSettings?.NEVER === "enable"
      ? "NEVER"
      : defaultPrintMode;

  const syncCouponUiState = useCallback(
    (cartData) => {
      const nextCoupon = cartData?.cartCoupon || null;

      if (nextCoupon?.couponValue) {
        dispatch(addcoupon(nextCoupon));
        setShowCoupon(true);
        return;
      }

      setShowCoupon(false);
      dispatch(addcoupon(null));
      localStorage.removeItem("cartCoupon");
      setCouponApplied("0");
      setContextCouponApplied?.("0");
    },
    [dispatch, setCouponApplied, setContextCouponApplied]
  );

  const sortCartProductsByModifiedDate = useCallback((cartProducts) => {
    if (!Array.isArray(cartProducts)) return null;

    return [...cartProducts].sort((a, b) => {
      const nextDate = b?.modifiedDate || "";
      const prevDate = a?.modifiedDate || "";
      return nextDate.localeCompare(prevDate);
    });
  }, []);

  const getAppliedDiscountDetails = useCallback((cartData) => {
    const billing = cartData?.billing || {};
    const rawAmount =
      Number(
        billing?.totalDiscountValue ??
          cartData?.appliedDiscount ??
          billing?.totalDiscount ??
          billing?.discount
      ) || 0;

    // The billing discount fields aggregate every discount including the coupon,
    // so strip the coupon portion to isolate the order-level discount
    const couponValue = Number(cartData?.cartCoupon?.couponValue ?? billing?.appliedCoupon) || 0;

    const amount = Math.max(Math.abs(rawAmount) - Math.abs(couponValue), 0);
    const type = cartData?.appliedDiscountType || (amount > 0 ? "FLAT_OFF" : "NONE");

    return {
      amount,
      type,
    };
  }, []);

  const getDisplayedItemTotal = useCallback((cartData) => {
    const billing = cartData?.billing || {};
    return billing?.totalSellingPriceValueWithoutTax ?? billing?.subtotal ?? "";
  }, []);

  const syncCartDiscountState = useCallback(
    (cartData) => {
      if (!cartData) return;

      const billing = cartData?.billing || {};
      const cartProducts = sortCartProductsByModifiedDate(cartData?.cartProducts);
      const appliedDiscountDetails = getAppliedDiscountDetails(cartData);

      if (cartData?.cartId) {
        setCartId(cartData.cartId);
        localStorage.setItem("CartId", cartData.cartId);
      }

      if (cartProducts) {
        setCartItems(cartProducts);
      }

      setOfferFound(!!cartData?.offerProductFound);
      setCartTotalQty(billing?.quantity || 0);
      setCgst(billing?.cgst);
      setSgst(billing?.sgst);
      setCess(billing?.totalCessAmount);
      setAppliedDiscountAmt(appliedDiscountDetails.amount);
      setAppliedDiscountType(appliedDiscountDetails.type);
      setSubTotal(getDisplayedItemTotal(cartData));
      setTotalTaxes(billing?.tax);
      setTotalValue(billing?.totalValue);
      setTotal(billing?.totalCartValue);
      setCouponApplied(billing?.appliedCoupon);
      setContextCouponApplied?.(billing?.appliedCoupon || "0");
      syncCouponUiState(cartData);
    },
    [
      getAppliedDiscountDetails,
      getDisplayedItemTotal,
      sortCartProductsByModifiedDate,
      setCartId,
      setCartItems,
      setContextCouponApplied,
      setCouponApplied,
      setSubTotal,
      setTotal,
      setTotalTaxes,
      syncCouponUiState,
    ]
  );
  // Keep ref in sync so effects can call the latest version without it being a reactive dependency
  syncCartDiscountStateRef.current = syncCartDiscountState;
  // Derived from print mode config — ALWAYS auto-prints, ASK defers to success screen, NEVER skips.
  // Applies uniformly to QSR and FINE_DINE, for every sale mode.
  const qsrSkipBill = billPrintMode !== "ALWAYS";
  const qsrSkipKot = kotPrintMode !== "ALWAYS";
  // Only call startPrint automatically if at least one mode is ALWAYS
  const shouldAutoPrint = !qsrSkipBill || !qsrSkipKot;
  const isFineDineDineIn = branchSubType === "FINE_DINE" && saleMode === "DINE_IN";
  const shouldAutoPrintForPayment = shouldAutoPrint && !isFineDineDineIn;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    color: "black",
  };

  // for avoiding go back to any last page in browser history after opening payment modal
  const [searchParams, setSearchParams] = useSearchParams();
  const modal = searchParams.get("modal");

  useEffect(() => {
    selectedManagerRef.current = selectedManager;
  }, [selectedManager]);

  useEffect(() => {
    if (searchParams.get("modal") === "pay") {
      setSearchParams(
        (prev) => {
          prev.delete("modal");
          return prev;
        },
        { replace: true }
      );
      setSearchParams(
        (prev) => {
          prev.delete("modal");
          return prev;
        },
        { replace: true }
      );
    }
  }, []);

  // Printer agent status for server polling
  const { startServerPolling, stopServerPolling } = usePrinterAgentStatus();

  // Start server polling when component mounts (for restaurant with cloud print enabled)
  useEffect(() => {
    // Check if cloud print is enabled
    let cloudPrintEnabled = false;
    try {
      const appConfig = JSON.parse(localStorage.getItem("appConfig"));
      cloudPrintEnabled = appConfig?.all?.CLOUD_PRINT?.flag === true;
    } catch {
      cloudPrintEnabled = false;
    }

    if (retailType === "RESTAURANT" && cloudPrintEnabled) {
      startServerPolling();
    }
    return () => {
      stopServerPolling();
    };
  }, [startServerPolling, stopServerPolling, retailType]);

  // Restore cart state on page refresh for restaurant
  useEffect(() => {
    if (retailType !== "RESTAURANT") return;
    const storedCartId = localStorage.getItem("CartId");
    if (!storedCartId) return;

    // Only run when cart is empty (page reload). Skip if cartItems already
    // populated by the table-layout's restaurantCreateCart response handler.
    if (cartItems?.length > 0) return;

    const storedTableData = JSON.parse(localStorage.getItem("selectedTableData") || "{}");
    const storedLastTable = JSON.parse(
      localStorage.getItem("restaurant_last_selected_table") || "{}"
    );
    const storedUser = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
    const storedBranchSubType = localStorage.getItem("branchSubType");
    const storedLocId = localStorage.getItem("locId");
    const storedOrgId = localStorage.getItem("orgId");
    const storedLicenseId = localStorage.getItem("licenseId");
    const storedSessionId = localStorage.getItem("sessionId");
    const storedLicenseName = localStorage.getItem("licenseName");

    const storedFineDineSaleMode = localStorage.getItem("fineDineSaleMode");
    const isFineDineNonTable =
      storedBranchSubType === "FINE_DINE" &&
      (storedFineDineSaleMode === "DELIVERY" || storedFineDineSaleMode === "TAKE_AWAY");

    const isRetrievingHoldCart = localStorage.getItem("retrieveHoldCart") === "true";

    const applyCartData = (data, overrideSaleMode) => {
      if (!data) return;
      syncCartDiscountState(data);
      if (data?.cartStatus === "ORDER_CREATED") {
        setShowFineDineActionButtons(true);
        setIsBillPrinted(true);
        if (data?.orderId) setPrintedBillOrderId(data?.orderId);
      }
      const mode =
        overrideSaleMode || (data?.subOrderType === "QSR_DINE_IN" ? "DINE_IN" : data?.subOrderType);
      if (mode) setSaleMode(mode);
      localStorage.setItem("CartId", data?.cartId);
      const storedCustomer = JSON.parse(localStorage.getItem("customer_details") || "{}");
      if (storedCustomer?.name) setCustomerName(storedCustomer.name);
      if (storedCustomer?.mobileNumber) setCustomerMobile(storedCustomer.mobileNumber);
    };

    if (isRetrievingHoldCart) {
      localStorage.removeItem("retrieveHoldCart");
      dataRetriveWhenPageRefresh(storedCartId)
        .then((res) => {
          applyCartData(res?.data?.data?.data);
        })
        .catch(() => {});
      return;
    }

    if (isFineDineNonTable) {
      dataRetriveWhenPageRefresh(storedCartId)
        .then((res) => {
          applyCartData(res?.data?.data?.data, storedFineDineSaleMode);
        })
        .catch(() => {});
      return;
    }

    const subOrderType =
      storedBranchSubType === "QSR" ? "QSR_DINE_IN" : storedTableData?.subOrderType || "DINE_IN";

    const payload = {
      cartId: storedCartId,
      tableNumber:
        storedTableData?.metadata?.tableName || storedTableData?.tableNoForDisplay || "1",
      tableId: `${storedTableData?.metadata?.tableMetadataId || "1"}`,
      layoutId: storedLastTable?.layoutId || storedTableData?.layoutId || null,
      layoutName: storedTableData?.layoutName || null,
      userName: null,
      userId: null,
      mobileNo: null,
      enableWhatsapp: true,
      createdBy: storedUser?.uidx,
      createdByName: storedUser?.firstName,
      updatedBy: storedUser?.uidx,
      updatedByName: storedUser?.firstName,
      locationId: storedLocId || "",
      sourceId: storedOrgId || "",
      licenseId: storedLicenseId || null,
      terminalName: storedLicenseName || null,
      orderType: "RESTAURANT_ORDER",
      subOrderType: subOrderType,
      sourceLocationId: storedLocId || "",
      sourceType: "RETAIL",
      channel: "POS",
      loggedInUser: storedUser?.uidx,
      sourceApp: "PALLET_POS",
      destinationId: storedOrgId || "",
      destinationLocationId: storedLocId || "",
      destinationType: "RETAIL",
      sessionId: storedSessionId || null,
      isTaxMasterEnabled: true,
    };

    restaurantCreateCart(payload)
      .then((res) => {
        const data = res?.data?.data?.data;
        if (!data || res?.data?.status === "error" || res?.data?.status === "ERROR") return;

        syncCartDiscountState(data);
        if (data?.subOrderType === "QSR_DINE_IN") {
          setSaleMode("DINE_IN");
        } else if (data?.subOrderType) {
          setSaleMode(data?.subOrderType);
        }
        localStorage.setItem("CartId", data?.cartId);
      })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Restore hold cart data when navigated from HoldOrderDrawer/HoldOrderPage
  useEffect(() => {
    const data = location.state?.holdCartData;
    const customer = location.state?.holdCustomer;
    if (!data) return;
    syncCartDiscountState(data);
    const subOrderType = data?.subOrderType;
    const mode = subOrderType === "QSR_DINE_IN" ? "DINE_IN" : subOrderType;
    if (mode) setSaleMode(mode);
    localStorage.setItem("CartId", data?.cartId);

    // Restore B2B sales order indicator
    if (data?.orderType === "SALES_ORDER") {
      localStorage.setItem("cartOrderType", "SALES_ORDER");
      setIsSalesOrder(true);
    } else {
      localStorage.removeItem("cartOrderType");
      setIsSalesOrder(false);
    }

    // FINE_DINE specific restoration
    if (branchSubType === "FINE_DINE") {
      if (mode === "DELIVERY" || mode === "TAKE_AWAY") {
        localStorage.setItem("fineDineSaleMode", mode);
      } else {
        localStorage.removeItem("fineDineSaleMode");
        // Restore table info for DINE_IN
        if (data?.tableNumber && data?.tableId) {
          setSelectedTable((prev) => ({
            ...prev,
            tableNoForDisplay: data?.tableNumber,
            tableMetadata: { ...prev?.tableMetadata, tableMetadataId: data?.tableId },
          }));
        }
      }
    }

    if (customer?.name) setCustomerName(customer.name);
    if (customer?.mobileNumber) setCustomerMobile(customer.mobileNumber);
    // Clear state so re-renders don't re-apply
    window.history.replaceState({}, "");
  }, [location.state?.holdCartData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!cartId) return;
    let cancelled = false;

    dataRetriveWhenPageRefresh(cartId)
      .then((res) => {
        if (!cancelled) syncCartDiscountStateRef.current(res?.data?.data?.data);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [cartId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const refreshCart = () => {
      const currentCartId = localStorage.getItem("CartId");
      if (!currentCartId) return Promise.resolve();
      setIsLoadingScreen(true);
      return dataRetriveWhenPageRefresh(currentCartId)
        .then((res) => syncCartDiscountStateRef.current?.(res?.data?.data?.data))
        .catch(() => {})
        .finally(() => setIsLoadingScreen(false));
    };
    setCartRefetch(() => refreshCart);
    return () => setCartRefetch(null);
  }, [setCartRefetch, setIsLoadingScreen]); // eslint-disable-line react-hooks/exhaustive-deps

  // Track time of last added item
  useEffect(() => {
    const currentLength = cartItems?.length || 0;
    if (currentLength > prevCartLengthRef.current) {
      const now = new Date();
      setLastAddedTime(
        now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })
      );
    }
    if (currentLength === 0) setLastAddedTime(null);
    prevCartLengthRef.current = currentLength;
  }, [cartItems?.length]);

  // Update hasRequestedForNewItem when cartItems change
  useEffect(() => {
    const hasRequestedForNewItemOne = cartItems?.some(
      (item) => item?.productStatus === "USER_REQUESTED"
    );
    setHasRequestedForNewItem(hasRequestedForNewItemOne);

    if (hasRequestedForNewItemOne) {
      setShowFineDineActionButtons(false);
    }
  }, [cartItems]);

  // ── Dual Screen BroadcastChannel sync ──────────────────────────────────────
  // Mount: open channel, listen for customer_found from the secondary window
  useEffect(() => {
    const ch = new BroadcastChannel("pos-dual-screen");
    dualScreenChannel.current = ch;

    ch.onmessage = ({ data: msg }) => {
      if (!msg?.type) return;
      if (msg?.type === "customer_found") {
        if (msg?.name) setCustomerName(msg?.name);
        if (msg?.mobile) setCustomerMobile(msg?.mobile);
      }
      // Secondary window just opened — replay the last cart state so it doesn't miss it
      if (msg?.type === "screen_ready" && dualScreenLastPayload.current) {
        try {
          ch.postMessage(dualScreenLastPayload.current);
        } catch (_) {}
      }
    };

    return () => {
      ch?.close();
      dualScreenChannel.current = null;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Broadcast cart state whenever items or billing changes
  useEffect(() => {
    const ch = dualScreenChannel.current;
    const payload = {
      type: "cart_update",
      items: (cartItems || []).map((item) => ({
        name: item?.productName || "",
        qty: item?.quantity || 1,
        price: item?.sellingPrice || 0,
        total: (item?.sellingPrice || 0) * (item?.quantity || 1),
      })),
      subtotal: subTotal || 0,
      tax: totalTaxes || 0,
      total: total || 0,
      discount: appliedDiscountAmt || 0,
      customerName,
      customerMobile,
    };
    // Always store latest payload — ref for screen_ready replay, localStorage for mount hydration
    dualScreenLastPayload.current = payload;
    try {
      localStorage.setItem("dualScreenCart", JSON.stringify(payload));
    } catch (_) {}
    if (!ch) return;
    try {
      ch.postMessage(payload);
    } catch (_) {
      /* channel closed */
    }
  }, [cartItems, total, totalTaxes, subTotal, customerName, customerMobile, appliedDiscountAmt]);
  // eslint-disable-line react-hooks/exhaustive-deps

  // Broadcast payment success
  useEffect(() => {
    if (!paymentSuccess) return;
    const ch = dualScreenChannel.current;
    if (!ch) return;
    try {
      ch.postMessage({
        type: "payment_success",
        customerName: customerName || "",
        total: total || 0,
        orderId: orderId || "",
      });
    } catch (_) {
      /* channel closed */
    }
  }, [paymentSuccess]); // eslint-disable-line react-hooks/exhaustive-deps
  // ── End Dual Screen sync ────────────────────────────────────────────────────

  // Aggregate cart items locally for list view (instead of calling cartAggsView API)
  const aggregatedCartProducts = useMemo(() => {
    if (!cartItems || cartItems.length === 0) return [];

    const aggregated = {};
    cartItems.forEach((item) => {
      // Create a unique key based on variantId, addon combination, and status
      // This ensures returned, complimentary, and normal products are grouped separately
      const addonKey =
        item?.addonProduct
          ?.map((a) => a?.variantId)
          .sort()
          .join("-") || "no-addon";
      const isReturned = item?.productStatus === "RETURNED";
      const isComplimentary = item?.inventoryStatus === "COMPLEMENTARY";
      const statusKey = isReturned ? "returned" : isComplimentary ? "complimentary" : "normal";
      const key = `${item?.variantId}-${addonKey}-${statusKey}`;

      if (!aggregated[key]) {
        aggregated[key] = {
          variantId: item?.variantId,
          productName: item?.productName,
          variantName: item?.variantName,
          foodType: item?.foodType,
          quantity: 0,
          subTotalWithoutTax: 0,
          addonProduct: item?.addonProduct || [],
          isReturned: isReturned,
          isComplimentary: isComplimentary,
          isBundle: item?.isBundle || false,
        };
      }

      aggregated[key].quantity += item?.quantity || 0;
      aggregated[key].subTotalWithoutTax += parseFloat(item?.subTotal + item?.addonSubTotal || 0);
    });

    return Object.values(aggregated);
  }, [cartItems]);

  useEffect(() => {
    setPrintBillLoader(false);
    const isOrderCreated = cartStatus === "ORDER_CREATED";
    if (isOrderCreated) {
      setShowFineDineActionButtons(true);
      setIsBillPrinted(true);
    } else {
      setShowFineDineActionButtons(false);
      setIsBillPrinted(false);
      setPrintedBillOrderId(null);
    }
  }, [saleMode, selectedTable, cartStatus]);

  useEffect(() => {
    const hasUserRequested = cartItems?.some((i) => i?.productStatus === "USER_REQUESTED");
    if (cartStatus === "ORDER_CREATED" && !hasUserRequested) return;
    if (cartItems?.length === 0 || (cartItems?.length > 0 && hasRequestedForNewItem)) {
      setPrintBillLoader(false);
      setShowFineDineActionButtons(false);
      setIsBillPrinted(false);
      setPrintedBillOrderId(null);
    }
  }, [cartItems?.length, hasRequestedForNewItem, cartStatus]);

  useEffect(() => {
    return () => {
      setPrintBillLoader(false);
    };
  }, []);

  useEffect(() => {
    if (modal === "pay") {
      if (cartItems?.length === 0) {
        // If cart is empty but CartId exists, load the cart first
        const storedCartId = localStorage.getItem("CartId");
        if (storedCartId) {
          dataRetriveWhenPageRefresh(storedCartId).then((res) => {
            const data = res?.data?.data?.data;
            if (data?.cartProducts?.length > 0) {
              setCartId(data?.cartId);
              setCartItems(data?.cartProducts);
              setCgst(data?.billing?.cgst);
              setSgst(data?.billing?.sgst);
              setCess(data?.billing?.totalCessAmount);
              setAppliedDiscountAmt(getAppliedDiscountDetails(data).amount);
              setAppliedDiscountType(getAppliedDiscountDetails(data).type);
              setSubTotal(getDisplayedItemTotal(data));
              setTotalTaxes(data?.billing?.tax);
              setTotalValue(data?.billing?.totalValue);
              setTotal(data?.billing?.totalCartValue);
              setContextCouponApplied(data?.billing?.appliedCoupon || "0");
              syncCouponUiState(data);
              syncCartDiscountState(data);
            }
          });
        }
        return;
      }
      if (!printerConfig) return;
      setOpenPayModal(true);
    } else {
      setOpenPayModal(false);
    }
  }, [modal, cartItems, setContextCouponApplied, syncCouponUiState]);

  const decreaseItemQuantity = (item, index) => {
    const shouldRemoveDiscountOnCartChange = appliedDiscountAmt > 0;
    setHighlightMrp(item?.sellingPrice);
    setIncreaseCartItemLoader(index);
    let payload = {
      cartId: cartId,
      sellingPrice: item?.sellingPrice,
      gtin: item?.gtin,
      locationId: locId,
      mrp: item?.mrp,
      inventoryChecks: "NO",
      batchNo: item?.batchNo,
      purchasePrice: item?.purchasePrice || "",
      quantityBySpecs: item?.quantityBySpecs,
      sellingUnit: item?.sellingUnit,
    };

    const addOnProductList = item?.addonProduct.map((addOnEle) => ({
      variantId: addOnEle?.variantId || "",
      itemName: addOnEle?.itemName || "",
      sellingPrice: addOnEle?.sellingPrice || 0,
      sellingUnit: addOnEle?.sellingUnit || "",
      specification: addOnEle?.specification || "",
      igst: addOnEle?.igst || 0,
      igstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cess: 0,
      cessAmount: 0,
    }));

    let restaurantPayload = {
      cartId: cartId,
      cartProductId: item?.cartProductId,
      qty: (item?.quantity || 0) - 1,
      addonProducts: addOnProductList,
    };

    if (retailType === "RESTAURANT") {
      updateProductQuantityOnCart(restaurantPayload)
        .then((res) => {
          if (
            res?.data?.status === "ERROR" ||
            res?.data?.status === "error" ||
            res?.data?.data?.es > 0 ||
            res?.data?.data?.status === "ERROR" ||
            res?.data?.data?.status === "error"
          ) {
            setIncreaseCartItemLoader(false);
            showSnackbar(res?.data?.data?.message || "Unable to update the quantity", "error");
            return;
          }
          const metaData = {
            itemId: restaurantPayload?.gtin,
            quantity: 1,
            sellingPrice: restaurantPayload?.sellingPrice,
            cartId: restaurantPayload?.cartId,
            mrp: restaurantPayload?.mrp,
          };
          eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
          const sortedProducts = res?.data?.data?.data?.cartProducts?.sort((a, b) =>
            b?.modifiedDate.localeCompare(a?.modifiedDate)
          );
          syncCartDiscountState(res?.data?.data?.data);
          setCartItems(sortedProducts);
          // Highlight the modified product
          if (sortedProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          setAppliedDiscountAmt(getAppliedDiscountDetails(res?.data?.data?.data).amount);
          setAppliedDiscountType(getAppliedDiscountDetails(res?.data?.data?.data).type);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setSubTotal(getDisplayedItemTotal(res?.data?.data?.data));
          setTotalTaxes(res?.data?.data?.data?.billing?.tax);
          setTotalValue(res?.data?.data?.data?.billing?.totalValue);
          setContextCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon || "0");
          syncCouponUiState(res?.data?.data?.data);
          removeDiscountAfterCartChange(res?.data?.data?.data, shouldRemoveDiscountOnCartChange);
          setCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon);
          setIncreaseCartItemLoader(false);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          myDiv.scrollTop = 0;
        })
        .catch((err) => {
          setIncreaseCartItemLoader(false);
          showSnackbar(err?.response?.data?.data?.message || err?.message, "error");
        });
    } else {
      decreaseItemThroughScanner(payload)
        .then((res) => {
          const metaData = {
            itemId: payload?.gtin,
            quantity: 1,
            sellingPrice: payload?.sellingPrice,
            cartId: payload?.cartId,
            mrp: payload?.mrp,
          };
          eventTracker({ metaData, eventType: eventTrackerConstant.CART_ITEM_REMOVED });
          const sortedProducts = res?.data?.data?.cartProducts.sort((a, b) =>
            b?.modifiedDate.localeCompare(a?.modifiedDate)
          );
          setCartItems(sortedProducts);
          // Highlight the modified product
          if (sortedProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }
          setOfferFound(res?.data?.data?.offerProductFound);
          setCartTotalQty(res?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.billing?.sgst);
          setCess(res.data.data.billing.totalCessAmount);
          setAppliedDiscountAmt(getAppliedDiscountDetails(res?.data?.data).amount);
          setAppliedDiscountType(getAppliedDiscountDetails(res?.data?.data).type);
          setTotal(res?.data?.data?.billing?.totalCartValue);
          setSubTotal(getDisplayedItemTotal(res?.data?.data?.data));
          setTotalTaxes(res?.data?.data?.billing?.tax);
          setTotalValue(res?.data?.data?.billing?.totalValue);
          setContextCouponApplied(res?.data?.data?.billing?.appliedCoupon || "0");
          syncCouponUiState(res?.data?.data);
          removeDiscountAfterCartChange(res?.data?.data, shouldRemoveDiscountOnCartChange);
          setIncreaseCartItemLoader(false);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          myDiv.scrollTop = 0;
        })
        .catch((err) => {
          setIncreaseCartItemLoader(false);
          showSnackbar(err?.response?.data?.message || err?.message, "error");
        });
    }
  };

  const increaseItemQuantity = (item, index) => {
    const shouldRemoveDiscountOnCartChange = appliedDiscountAmt > 0;
    setIncreaseCartItemLoader(index);
    setHighlightMrp(item?.sellingPrice);
    let payload = {
      cartId: cartId,
      sellingPrice: item?.sellingPrice,
      gtin: item?.gtin,
      locationId: locId,
      mrp: item?.mrp,
      inventoryChecks: "NO",
      batchNo: item?.batchNo,
      purchasePrice: item?.purchasePrice || "",
      quantityBySpecs: item?.quantityBySpecs,
      sellingUnit: item?.sellingUnit,
      expiryDate: item?.expiryDate?.split("+")[0],
      variantName: item?.productName,
      vendorId: item?.vendorId,
      packagingType: item?.packagingType,
      brandName: item?.brand,
    };

    const addOnProductList = item?.addonProduct.map((addOnEle) => ({
      variantId: addOnEle?.variantId || "",
      itemName: addOnEle?.itemName || "",
      sellingPrice: addOnEle?.sellingPrice || 0,
      sellingUnit: addOnEle?.sellingUnit || "",
      specification: addOnEle?.specification || "",
      igst: addOnEle?.igst || 0,
      igstAmount: 0,
      cgst: 0,
      cgstAmount: 0,
      sgst: 0,
      sgstAmount: 0,
      cess: 0,
      cessAmount: 0,
      quantity: addOnEle?.quantity || 0,
    }));

    let restaurantPayload = {
      cartId: cartId,
      cartProductId: item?.cartProductId,
      sellingPrice: item?.sellingPrice,
      variantId: item?.variantId,
      vendorId: item?.vendorId || "",
      qty: (item.quantity || 0) + 1,
      locationId: locId,
      mrp: item?.sellingPrice || 0,
      purchasePrice: item?.purchasePrice || 0,
      sellingUnit: item?.sellingUnit || "",
      quantityBySpecs: item?.quantityBySpecs || "",
      productStatus: item.productStatus,
      addonProducts: addOnProductList,
    };

    if (retailType === "RESTAURANT") {
      updateProductQuantityOnCart(restaurantPayload)
        .then((res) => {
          const sortedProducts = res?.data?.data?.data?.cartProducts.sort((a, b) =>
            b?.modifiedDate.localeCompare(a?.modifiedDate)
          );
          syncCartDiscountState(res?.data?.data?.data);
          setCartItems(sortedProducts);
          // Highlight the modified product
          if (sortedProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          setAppliedDiscountAmt(getAppliedDiscountDetails(res?.data?.data?.data).amount);
          setAppliedDiscountType(getAppliedDiscountDetails(res?.data?.data?.data).type);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setSubTotal(getDisplayedItemTotal(res?.data?.data?.data));
          setTotalTaxes(res?.data?.data?.data?.billing?.tax);
          setTotalValue(res?.data?.data?.data?.billing?.totalValue);
          setContextCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon || "0");
          syncCouponUiState(res?.data?.data?.data);
          removeDiscountAfterCartChange(res?.data?.data?.data, shouldRemoveDiscountOnCartChange);
          setCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon);
          setIncreaseCartItemLoader(null);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          myDiv.scrollTop = 0;
          if (res?.data?.status === "SUCCESS" && res?.data?.data?.es === 1) {
            showSnackbar(res?.data?.data?.message || "Error while incereasing quantity");
          }
        })
        .catch((err) => {
          setIncreaseCartItemLoader(null);
          showSnackbar(err?.response?.data?.message || err?.message, "error");
        });
    } else {
      addItemDirect(payload, cartItems, {
        onBeforeError: () => setIncreaseCartItemLoader(null),
        onSuccess: (cartData) => {
          const sortedProducts = cartData?.cartProducts?.sort((a, b) =>
            b?.modifiedDate.localeCompare(a?.modifiedDate)
          );
          syncCartDiscountState(cartData);
          setCartItems(sortedProducts);
          // Highlight the modified product
          if (sortedProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }
          setAppliedDiscountAmt(getAppliedDiscountDetails(cartData).amount);
          setAppliedDiscountType(getAppliedDiscountDetails(cartData).type);
          setSubTotal(getDisplayedItemTotal(cartData));
          setCouponApplied(cartData?.billing?.appliedCoupon);
          setContextCouponApplied(cartData?.billing?.appliedCoupon || "0");
          syncCouponUiState(cartData);
          removeDiscountAfterCartChange(cartData, shouldRemoveDiscountOnCartChange);
          setIncreaseCartItemLoader(null);
          setanimationBox(true);
          setItemgtin(item?.gtin);
          myDiv.scrollTop = 0;
        },
      });
    }
  };

  const handleFineDineSaleModeChange = (mode) => {
    if (mode === "DINE_IN") {
      setSaleMode("DINE_IN");
      localStorage.removeItem("fineDineSaleMode");
      navigate("/products/table-layout");
      return;
    }
    localStorage.setItem("fineDineSaleMode", mode);
    handleOptionChange({ target: { value: mode } });
  };

  const handleProceed = () => {
    if (isMobile) {
      navigate("/grocery/cart");
      return;
    }

    handleOpenPaymentModal();
  };

  useEffect(() => {
    const customerData = localStorage.getItem("customer_details");
    const savedNumber = JSON.parse(customerData)?.mobileNumber;
    const savedName = JSON.parse(customerData)?.name;
    if (customerData) {
      setCustomerMobile(savedNumber);
      setCustomerName(savedName);
    }
  }, [customer_data]);

  useEffect(() => {
    if (openCustomerDetailTrigger > 0) {
      setOpenCartCustomerDetail(true);
    }
  }, [openCustomerDetailTrigger]);

  const handleNewCart = () => {
    setOpenCartCustomerDetail((prev) => !prev);
  };

  const thirdrefElement = useRef(null);

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        const focusableElements = thirdrefElement?.current?.querySelectorAll(
          'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstElement = focusableElements?.[0];
        const lastElement = focusableElements?.[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
      if (e?.key === "3" && e?.altKey) {
        document.getElementById("myDiv3").focus();
      }
      if (e?.key === "4" && e?.altKey) {
        document.getElementById("myDiv4").focus();
      }
    });
  }, []);

  const handleCloseModal = () => setOpenDelete(false);
  const handleCloseModalLoyalty = useCallback(() => setLoyaltyModal(false), []);
  const handleDeliveryPopUp = useCallback(() => setOpenDelivery(true), []);
  const handleCloseDeliveryPopUp = useCallback(() => setOpenDelivery(false), []);
  const handleOpenOfferCheckModal = useCallback(() => setOfferCheckModal(true), []);
  const handleCloseOfferCheckModal = useCallback(() => setOfferCheckModal(false), []);

  const handleManagerModalOpen = useCallback(() => {
    customEventTrigger("pos_change_payment_mode");
    setmanagerModal(true);
  }, []);

  const handleManagerModalClose = useCallback(() => setmanagerModal(false), []);

  const handleFlush = () => {
    setdeleteLoader(true);
    flushCart(cartId)
      .then((res) => {
        setOpenDelete(false);
        setShowText(false);
        const totalItems = cartItems.reduce(
          (totalQuantity, item) => totalQuantity + item.quantity,
          0
        );

        const metaData = {
          cartId: cartId,
          itemsCount: totalItems,
          amount: total,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.CART_DELETED });
        dispatch(resetStateWithoutTime(0));
        const backupData = {
          ...orderMetricDataFullState,
          manuallyAdded: 0,
          scannedProduct: 0,
          isMultipleBatch: false,
          avgProductAddTime: "",
          totalProducts: 0,
          productTimeArray: [],
          editOrderItem: 0,
          manuallyRemovedItems: 0,
          manualItemsGtin: [],
        };
        localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        dataRetriveWhenPageRefresh(cartId).then((res) => {
          syncCartDiscountState(res?.data?.data?.data);
          if (retailType === "RESTAURANT") {
            if (res?.data?.data?.data?.subOrderType === "QSR_DINE_N") {
              setSaleMode("DINE_IN");
            } else {
              setSaleMode(res?.data?.data?.data?.subOrderType || "DINE_IN");
            }
          } else {
            setSaleMode(res?.data?.data?.data?.subOrderType || "DINE_IN");
          }

          setdeleteLoader(false);
          setContextCouponApplied?.(res?.data?.data?.data?.billing?.appliedCoupon || "0");
          syncCouponUiState(res?.data?.data?.data);
          setCartStatus(res?.data?.data?.data?.cartStatus);
        });
      })
      .catch((err) => {
        setdeleteLoader(false);
        setOpenDelete(false);
      });
  };

  var myDiv = document.getElementById("scrollTopDiv");
  function captureScrollPosition() {
    var scrollPosition = myDiv.scrollTop;
  }
  myDiv?.addEventListener("scroll", captureScrollPosition);

  const deleteCartItem = () => {
    setOpenDelete(true);
  };

  const confettiOptions = {
    force: 0.3,
    duration: 2200,
    particleSize: 12,
    particleCount: 70,
    width: 900,
  };

  useEffect(() => {
    if (isExploding) {
      const timeoutId = setTimeout(() => {
        setIsExploding(false);
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [isExploding]);

  const handleCloseOfferModal = () => {
    setOpenOffer(false);
  };

  const handleFlushClick = () => {
    openAuthModal(() => handleFlush());
  };

  const handleOptionChange = (event) => {
    setComplimentaryMode(false);
    const selectedSaleMode = event.target.value;
    setLoader((prev) => ({ ...prev, [selectedSaleMode]: true }));
    setSaleMode(selectedSaleMode);

    if (retailType === "RESTAURANT") {
      // Set subOrderType to QSR_DINE_IN for QSR branch with DINE_IN sale mode
      const subOrderType =
        branchSubType === "QSR" && selectedSaleMode === "DINE_IN"
          ? "QSR_DINE_IN"
          : selectedSaleMode;

      const fineDineTableId =
        branchSubType === "FINE_DINE" && selectedSaleMode === "DELIVERY"
          ? "DELIVERY"
          : branchSubType === "FINE_DINE" && selectedSaleMode === "TAKE_AWAY"
          ? "TAKEAWAY"
          : "1";

      let restaurantPayload = {
        cartId: null,
        userName:
          branchSubType === "QSR" && customerName
            ? customerName
            : retailUserLocalStorageData?.name || null,
        userId: retailUserLocalStorageData?.uidx || null,
        tableNumber: fineDineTableId,
        tableId: fineDineTableId,
        mobileNo: branchSubType === "QSR" && customerMobile ? customerMobile : null,
        enableWhatsapp: true,
        createdBy: retailUserLocalStorageData?.uidx,
        createdByName: retailUserLocalStorageData?.firstName,
        updatedBy: retailUserLocalStorageData?.uidx,
        updatedByName: retailUserLocalStorageData?.firstName,
        locationId: locId || "",
        sourceId: orgId || "",
        licenseId: licenseId || null,
        terminalName: licenseName || null,
        orderType: "RESTAURANT_ORDER",
        subOrderType: subOrderType,
        sourceLocationId: locId || "",
        sourceType: "RETAIL",
        channel: "POS",
        loggedInUser: retailUserLocalStorageData?.uidx,
        sourceApp: "PALLET_POS",
        destinationId: orgId || "",
        destinationLocationId: locId || "",
        destinationType: "RETAIL",
        sessionId: sessionId || null,
        isTaxMasterEnabled: true,
      };

      const mySeq = ++saleModeSeqRef.current;
      restaurantCreateCart(restaurantPayload)
        .then((res) => {
          // Ignore stale responses from previous rapid mode switches
          if (saleModeSeqRef.current !== mySeq) return;
          const customer_details = {
            name: res?.data?.data?.data?.userName || null,
            mobileNumber: res?.data?.data?.data?.mobileNo || null,
            uidx: res?.data?.data?.data?.userId || null,
            whatsapp: res?.data?.data?.data?.enableWhatsapp || null,
          };
          if (!cartItems.length) {
            const currentTime = new Date().getTime();
            dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
            dispatch(changePrevAddedTime(currentTime));
            const orderMetricData = {
              startTime: currentTime,
              prevAddedProductTime: currentTime,
              startTimeAdded: true,
              manuallyAdded: 0,
              scannedProduct: 0,
              isMultipleBatch: false,
              avgProductAddTime: "",
              totalProducts: 0,
              productTimeArray: [],
              editOrderItem: 0,
              manuallyRemovedItems: 0,
              manualItemsGtin: [],
            };
            localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
            setLoader(false);
          }
          showSnackbar("Sale mode changed and price updated", "success");
          setCartId(res?.data?.data?.data?.cartId);
          setCartItems(res?.data?.data?.data?.cartProducts || []);
          setCartTotalQty(res?.data?.data?.data?.billing?.quantity);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing.sgst);
          setCess(res?.data?.data?.data?.billing.totalCessAmount);
          setSubTotal(getDisplayedItemTotal(res?.data?.data?.data));
          setTotalTaxes(res?.data?.data?.data?.billing?.tax);
          setTotalValue(res?.data?.data?.data?.billing?.totalValue);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setContextCouponApplied?.(res?.data?.data?.data?.billing?.appliedCoupon || "0");
          syncCouponUiState(res?.data?.data?.data);
          setAdjustCheck(false);
          if (branchSubType === "QSR") {
            const resName = res?.data?.data?.data?.userName;
            const resMobile = res?.data?.data?.data?.mobileNo;
            if (resName) setCustomerName(resName);
            if (resMobile) setCustomerMobile(resMobile);
            else if (!resName && !resMobile) setCustomerMobile("");
          } else {
            setCustomerMobile("");
          }
          setSplitActive(false);
          setPartailStatus(false);
          setLoader(false);
          const cartProducts = res?.data?.data?.data?.cartProducts;
          const isOutOfStck = cartProducts?.find(
            (item) => item?.inventoryStatus === "OUT_OF_STOCK"
          );
          setDisableProceed(!!isOutOfStck);
          setCartStatus(res?.data?.data?.data?.cartStatus);
          if (res?.data?.data?.data?.cartStatus === "ORDER_CREATED") {
            setShowFineDineActionButtons(true);
            setIsBillPrinted(true);
            setPrintedBillOrderId(res?.data?.data?.data?.orderId);
            setNewId(res?.data?.data?.data?.orderId);
          }
          localStorage.setItem("CartId", res?.data?.data?.data?.cartId);
          localStorage.setItem("sessionId", sessionId);
          localStorage.setItem("licenseId", licenseId);
          localStorage.setItem("customer_details", JSON.stringify(customer_details));
          localStorage.removeItem("loyaltyDetails");
          isMobilePos &&
            emit({
              type: "localData",
              data: {
                CartId: res?.data?.data?.data?.cartId,
                customer_details: customer_details,
              },
            });
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setLoader(false);
        });
    }
  };

  const handleOpenPaymentModal = () => {
    setPrintBillLoader(false);

    customEventTrigger("pos_payment_page");
    if (!printerConfig) {
      showSnackbar("Please configure printer from Settings > Peripherals", "warning");
      return;
    } else if (cartItems?.length === 0) {
      showSnackbar("Your cart is empty. Please add an item to proceed", "info");
      return;
    }
    if (amtHeading === "Recievable Amount") {
      setEnterAmount(calculateRoundedAmount(amtToBePaid));
    } else {
      setEnterAmount("");
    }
    // Restaurant desktop: open RestaurantPaymentModal inline instead of navigating away.
    // Mobile restaurant sessions continue to navigate to the unified payment screen.
    if (retailType === "RESTAURANT" && !isMobile) {
      setOpenPayModal(true);
      return;
    }
    navigate("/grocery/cart", { state: { returnTo: "/restaurant/cart" } });
  };

  const handleManual = () => {
    setManaul(true);
  };

  // ENHANCED: resetValues - updates table cache in localStorage to mark table as AVAILABLE
  const resetValues = () => {
    const currentCartId = localStorage.getItem("CartId") || CartId;

    if (currentCartId && lastResetCartIdRef.current === currentCartId) {
      return;
    }

    if (currentCartId) {
      lastResetCartIdRef.current = currentCartId;
    }

    setIsBillPrinted(false);
    setPrintedBillOrderId(null);
    setPaymentLoadingModal(false);
    // qsrSkipBill / qsrSkipKot are derived from print mode config, no reset needed
    setCartItems([]);
    setCartTotalQty("0");
    setSingleOrderOffline(false);
    setSplitActive(false);
    setEnterAmount("");
    setIsSalesOrder(false);
    localStorage.removeItem("loyaltyPoints");
    localStorage.removeItem("loyaltyDetails");
    localStorage.removeItem("CartId");
    localStorage.removeItem("fineDineSaleMode");
    localStorage.removeItem("cartOrderType");
    localStorage.removeItem("b2bPartnerName");
    setSlotDetails({ slotId: "", cutoffId: "", startTime: "", endTime: "" });

    // ENHANCED: Update table status to AVAILABLE in localStorage cache
    try {
      const savedTable = JSON.parse(localStorage.getItem("restaurant_last_selected_table"));
      if (savedTable?.tableMapId) {
        let layoutId = savedTable?.layoutId;

        if (!layoutId) {
          const storedSelection = JSON.parse(
            localStorage.getItem("restaurant_selected_floor_area")
          );
          layoutId = storedSelection?.area?.value;
        }

        if (layoutId) {
          const cacheKey = `restaurant_tables_${layoutId}`;
          const cachedData = localStorage.getItem(cacheKey);

          if (cachedData) {
            const tables = JSON.parse(cachedData);
            const updatedTables = tables.map((table) => {
              if (table?.mapId === savedTable?.tableMapId) {
                // Mark table as AVAILABLE and clear all status fields
                return {
                  ...table,
                  status: "AVAILABLE",
                  cartStatus: null,
                  statusCartId: null,
                  statusOrderId: null,
                  totalCartValue: 0,
                  kitchenCount: 0,
                };
              }
              return table;
            });

            // Save updated tables back to cache
            localStorage.setItem(cacheKey, JSON.stringify(updatedTables));
          }
        }

        // Keep restaurant_last_selected_table so table layout can highlight it when modal reopens
      }
    } catch (error) {}

    dispatch(addcoupon("---"));
    setPayLoader(false);
    setCashChange(false);
    setPartailStatus(false);
    setPreviousAmountPaid("");
    setAmountPaid("");
    setPAmt("");
    setSgst("");
    setCess("");
    setCgst("");
    setAppliedDiscountAmt(0);
    setAppliedDiscountType("NONE");
    setSubTotal("");
    setTotalTaxes("");
    setTotalValue("");
    setAppliedDiscountAmt(0);
    setAppliedDiscountType("NONE");
    setAdjustCheck(false);
    setAmountPaid("");
    setTotal("");
    setComments("");

    const customer_details = {
      name: null,
      mobileNumber: null,
      uidx: null,
      whatsapp: false,
    };
    localStorage.setItem("customer_details", JSON.stringify(customer_details));

    if (retailType === "RESTAURANT" && branchSubType === "FINE_DINE" && saleMode === "DINE_IN") {
      const payload = {
        cartId: currentCartId,
        closedBy: retailUserLocalStorageData?.uidx,
        closedByName: retailUserLocalStorageData?.firstName,
        comments: "Cart closed",
      };
      if (currentCartId) {
        restaurantCartClose(payload)
          .then((res) => {
            if (
              res?.data?.data?.es > 0 ||
              res?.data?.data?.data?.es > 0 ||
              res?.data?.es > 0 ||
              res?.data?.status === "ERROR" ||
              res?.data?.data?.status === "ERROR"
            ) {
              return;
            }
            localStorage.removeItem("CartId");
            localStorage.removeItem("fineDineSaleMode");
          })
          .catch((err) => {});
      }
    }

    setCartStatus(null);
  };

  const handleTansactionCancel = () => {
    setCancelLoader(true);
    let payload = {
      orderId: newId,
      transactionCode: newTransId,
    };
    orderCancelRequest(payload).then((res) => {
      if (res?.data?.data?.statusModel?.orderStatus === "PAYMENT_CANCELLED") {
        setPaymentLoadingModal(false);
        setCancelLoader(false);
        setPartailStatus(false);
        setEnterAmount("");
      } else if (res?.data?.data?.statusModel?.paymentStatus === "PAYMENT_PENDING") {
        setPaymentLoadingModal(false);
        setCancelLoader(false);
        setPartailStatus(true);
        setEnterAmount("");
        setOrderStatus(true);
        callPaymentStatus(newTransId);
      }
    });
  };

  const callPaymentStatus = (transId, currentRetry) => {
    let maxRetries = 95;
    let retry = currentRetry || 0;
    setEnterAmount(enterAmount);
    if (storeMode === "OFFLINE") {
      callGetOrder(newId);
      return;
    }
    getPaymentStatus(transId)
      .then((res) => {
        if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_INITIATED" &&
          retry < maxRetries
        ) {
          retry++;
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setpaymentLoader(true);
          setPaymentSuccess(false);
          setTimeout(() => callPaymentStatus(transId, retry), 2000 + retry);

          if (retry === maxRetries) {
            setPaymentFailed(true);
            setCancelTarsn(true);
          }
        } else if (res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED") {
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          callGetOrder(res?.data?.data?.paymentResponseModel?.orderId);
        } else if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_CANCELLED" ||
          res?.data?.data?.paymentResponseModel?.paymentStatus === "CANCELLED"
        ) {
          retry === maxRetries;
          setPaymentLoadingModal(false);
          setCancelLoader(false);
          setPartailStatus(true);
          setCancelledOnce(true);
          setEnterAmount("");
          setpaymentLoader(false);
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "error");
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const handleManualorders = () => {
    const machineId = localStorage.getItem("machineId");
    setApproveLoader(true);
    let payload = {
      mobile: mobileNumber,
      primaryPassword: cashierPin,
    };
    let completePayload = {
      referenceId: newId,
      transactionCode: newTransId,
      paymentStatus: "COMPLETED",
      amountPaid: splitActive ? enterAmount : total,
      paymentType: "MANUAL",
      paymentMethod: paymentMethod,
      paymentMode: singleOrderoffline
        ? "OFFLINE"
        : storeMode === "OFFLINE" || !machineId
        ? "OFFLINE"
        : "ONLINE",
    };
    validateManagerPin(payload)
      .then((res) => {
        showSnackbar("Success Pin verified", "success");
        completePayment(completePayload)
          .then((res) => {
            if (
              res?.data?.data?.paymentResponseModel?.orderStatus === "PARTIALLY_PAID" ||
              res?.data?.data?.paymentResponseModel?.orderStatus === "PAYMENT_PENDING"
            ) {
              showSnackbar("Partially Paid", "success");
              setApproveLoader(false);
              setPartailStatus(true);
              setPaymentLoadingModal(false);
              setManaul(false);
              setAmountPaid(res?.data?.data?.paymentResponseModel?.amountPaid);
              setAmountDue(res?.data?.data?.paymentResponseModel?.outStandingAmount);
            } else if (
              res?.data?.data?.paymentResponseModel?.orderStatus === "PAID" &&
              res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED"
            ) {
              setApproveLoader(false);
              orderMetricsApiCall();
              showSnackbar("Payment Success", "success");

              if (
                (branchSubType === "FINE_DINE" &&
                  (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) ||
                branchSubType !== "FINE_DINE"
              ) {
                shouldAutoPrintForPayment &&
                  startPrint({
                    orderId: newId,
                    skipBill: qsrSkipBill,
                    skipKot: qsrSkipKot,
                    ...(saleMode === "DELIVERY" && { orderSource: "b2c" }),
                  });
              } else {
                if (paymentMethod === "CASH") {
                  openDrawer();
                }
              }
              setManaul(false);
            }
          })
          .catch((err) => {
            showSnackbar(err?.response?.data?.message || err?.message, "error");
            setPaymentFailed(true);
            setApproveLoader(false);
            setTimeout(() => {
              setCartItems([]);
              setCartTotalQty("0");
              setOpen(true);
            }, 2000);
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setApproveLoader(false);
      });
  };

  const digitalPaymentFunUPI = () => {
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    customEventTrigger(`pos_payment_method`, {
      payment_method: `selected_method_${paymentMethod}`,
    });
    setModalLoader(true);
    let cart_ID = localStorage.getItem("CartId");
    const machineId = localStorage.getItem("machineId");
    const isWhatsapp = customer_data ? JSON.parse(customer_data)?.whatsapp : false;

    // Check if printer agent is online for this location
    const SEND_TO_KITCHEN_KEY = "sendToKitchen";
    let sendToKitchenEnabled = false;
    try {
      sendToKitchenEnabled = localStorage.getItem(SEND_TO_KITCHEN_KEY) === "true";
    } catch {
      sendToKitchenEnabled = false;
    }

    // Determine if sendToKitchen should be included
    const shouldSendToKitchen =
      branchSubType === "FINE_DINE" &&
      (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY") &&
      sendToKitchenEnabled;

    const shouldKDS =
      isKDSRequired && branchSubType === "FINE_DINE"
        ? saleMode === "DELIVERY" || saleMode === "TAKE_AWAY"
        : saleMode === "DELIVERY" || saleMode === "TAKE_AWAY" || saleMode === "DINE_IN";

    // Apply rounding to all amounts
    const roundedTotal = calculateRoundedAmount(total);
    const roundedEnterAmount = calculateRoundedAmount(enterAmount);
    const roundedAmtToBePaid = calculateRoundedAmount(amtToBePaid);

    const change = adjustCheck
      ? (Number(roundedEnterAmount) - Number(roundedAmtToBePaid)).toFixed(2)
      : (Number(roundedEnterAmount) - Number(roundedTotal)).toFixed(2);

    let payload = {
      sessionId: sessionId,
      licenseId: licenseId,
      licenseName: licenseName,
      machineCode: machineId,
      cartId: cart_ID,
      paymentMode: singleOrderoffline
        ? "OFFLINE"
        : storeMode === "OFFLINE" || !machineId
        ? "OFFLINE"
        : "ONLINE",
      paymentMethod: paymentMethod,
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      tender: roundedEnterAmount,
      currentUserName: firstName,
      balance:
        paymentMethod === "CARD" || paymentMethod === "UPI" || paymentMethod === "DEBIT_NOTE"
          ? "0"
          : String(Math.abs(change)),
      whatsapp: isWhatsapp,
      amount: splitActive
        ? roundedEnterAmount
        : adjustCheck
        ? Math.abs(amountPaid - roundedTotal)
        : roundedTotal,
      slotId: slotDetails?.slotId || "",
      cutoffId: slotDetails?.cutoffId || "",
      startTime: slotDetails?.startTime || "",
      endTime: slotDetails?.endTime || "",
      orderedBy: uidx,
      orderedByName: retailUserName,
      ...(shouldSendToKitchen && !qsrSkipKot && { isPrintNeeded: true }),
      ...(shouldKDS && { isSendToKitchen: true }),
      ...(orderBumpingMode === "AUTO" ? { isAutoAccepted: true } : { isAutoAccepted: false }),
    };

    CreateRestaurantOrder(payload)
      .then((res) => {
        showSnackbar("Payment under progress", "info");
        setModalLoader(false);
        setpaymentLoader(true);
        if (res?.data?.data?.es === 1) {
          showSnackbar(
            res?.data?.data?.message || "Something went wrong. Please try again.",
            "error"
          );
          setModalLoader(false);
          setpaymentLoader(false);
        } else {
          setModalLoader(false);
          setNewId(res?.data?.data?.orderResponseModel?.orderId);
          setNewTransId(res?.data?.data?.orderResponseModel?.transactionCode);
          if (storeMode === "OFFLINE") {
            callGetOrder(res?.data?.data?.orderResponseModel?.orderId);
          } else {
            callPaymentStatus(res?.data?.data?.orderResponseModel?.transactionCode);
          }
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setOpen(false);
        setModalLoader(false);
      });
  };

  // In Cart.jsx, replace the createOrderFun function with this updated version:

  const createOrderFun = async () => {
    // Check if this is a zero-value order
    const isZeroOrder = Number(total) === 0 || Number(amtToBePaid) === 0;

    if (paymentMethod === "CASH" && !isZeroOrder) {
      if (typeof enterAmount === "string" && !enterAmount.trim()) {
        showSnackbar("Please enter amount to proceed", "error");
        setIsButtonDisabled(false);
        return;
      }
      if (!enterAmount || enterAmount === 0) {
        showSnackbar("Please enter amount to proceed", "error");
        setIsButtonDisabled(false);
        return;
      }
    }

    if (!isZeroOrder && (branchSubType !== "FINE_DINE" || paymentMethod !== "CASH")) {
      if (typeof enterAmount === "string" && !enterAmount.trim()) {
        showSnackbar("Please enter amount to proceed", "error");
        setIsButtonDisabled(false);
        return;
      }
    }

    // Apply rounding to all amounts
    const roundedTotal = calculateRoundedAmount(total);
    const roundedEnterAmount = isZeroOrder ? "0" : calculateRoundedAmount(enterAmount);
    const roundedAmtToBePaid = calculateRoundedAmount(amtToBePaid);

    if (
      !isZeroOrder &&
      amtHeading === "Payable Amount" &&
      Number(roundedEnterAmount) < Number(roundedAmtToBePaid) &&
      adjustCheck &&
      saleMode == "in-store"
    ) {
      showSnackbar("Please enter a valid amount to proceed", "error");
      setIsButtonDisabled(false);
      return;
    }
    if (
      !isZeroOrder &&
      !splitActive &&
      Number(roundedEnterAmount) < Number(roundedTotal) &&
      !adjustCheck &&
      saleMode == "in-store"
    ) {
      showSnackbar("Please enter a valid amount to proceed", "error");
      setIsButtonDisabled(false);
      return;
    }

    setNewLoader(true);
    setIsPlacingDelivery(true);
    setPaymentSuccessfulLoader(true);
    let cart_ID = localStorage.getItem("CartId");
    const isWhatsapp = customer_data ? JSON.parse(customer_data)?.whatsapp : false;

    // Check if printer agent is online for this location
    const SEND_TO_KITCHEN_KEY = "sendToKitchen";
    let sendToKitchenEnabled = false;
    try {
      sendToKitchenEnabled = localStorage.getItem(SEND_TO_KITCHEN_KEY) === "true";
    } catch {
      sendToKitchenEnabled = false;
    }

    // Determine if sendToKitchen should be included
    const shouldSendToKitchen =
      branchSubType === "FINE_DINE" &&
      (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY") &&
      sendToKitchenEnabled;

    const shouldKDS =
      isKDSRequired && branchSubType === "FINE_DINE"
        ? saleMode === "DELIVERY" || saleMode === "TAKE_AWAY"
        : saleMode === "DELIVERY" || saleMode === "TAKE_AWAY" || saleMode === "DINE_IN";

    const change = adjustCheck
      ? (Number(roundedEnterAmount) - Number(roundedAmtToBePaid)).toFixed(2)
      : (Number(roundedEnterAmount) - Number(roundedTotal)).toFixed(2);

    let createOrderPayload = {
      sessionId: sessionId,
      licenseId: licenseId,
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      licenseName: licenseName,
      machineCode: "CASH",
      cartId: cart_ID,
      paymentMode: storeMode === "OFFLINE" ? "OFFLINE" : "ONLINE",
      paymentMethod: saleMode === "delivery" ? "COD" : paymentMethod || (isZeroOrder ? "CASH" : ""),
      inventoryCheck: "NO",
      tender: roundedEnterAmount,
      balance: String(Math.abs(change)),
      whatsapp: isWhatsapp,
      amount: roundedEnterAmount,
      slotId: slotDetails?.slotId || "",
      cutoffId: slotDetails?.cutoffId || "",
      startTime: slotDetails?.startTime || "",
      endTime: slotDetails?.endTime || "",
      orderedBy: uidx,
      orderedByName: retailUserName,
      ...(shouldSendToKitchen && !qsrSkipKot && { isPrintNeeded: true }),
      ...(shouldKDS && { isSendToKitchen: true }),
      ...(orderBumpingMode === "AUTO" ? { isAutoAccepted: true } : { isAutoAccepted: false }),
    };

    customEventTrigger(`pos_payment_method`, {
      payment_method: `selected_method_${paymentMethod}`,
    });

    await CreateRestaurantOrder(createOrderPayload)
      .then((res) => {
        if (!!res?.data?.data?.es) {
          showSnackbar(
            res?.data?.data?.message || "Something went wrong. Please try again.",
            "error"
          );
          setNewLoader(false);
          setPaymentSuccessfulLoader(false);
          setIsPlacingDelivery(false);
          setIsButtonDisabled(false);
          return;
        }
        let orderId = res?.data?.data?.orderResponseModel?.orderId;

        if (splitActive) {
          getOrderDetails(orderId, locId)
            .then((res) => {
              if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PARTIALLY_PAID") {
                showSnackbar(res?.data?.data?.baseOrderResponse?.orderStatus, "success");
                setEnterAmount("");
                setAmountPaid(res?.data?.data?.baseOrderResponse?.amountPaid);
                setAmountDue(res?.data?.data?.baseOrderResponse?.outstandingAmount);
                setNewId(res?.data?.data?.baseOrderResponse?.orderId);
                setPartailStatus(true);
                setNewLoader(false);
              } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "COMPLETED") {
                // ✅ FIXED: Handle completion similar to UPI/CARD
                setIsPlacingDelivery(false);
                setNewLoader(false);
                setPartailStatus(false);
                setSplitActive(false);
                setModalLoader(false);
                setpaymentLoader(true);
                setPaymentSuccess(true);
                orderMetricsApiCall();

                if (
                  (branchSubType === "FINE_DINE" &&
                    (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) ||
                  branchSubType !== "FINE_DINE"
                ) {
                  shouldAutoPrintForPayment &&
                    startPrint({
                      orderId: orderId,
                      skipBill: qsrSkipBill,
                      skipKot: qsrSkipKot,
                      ...(saleMode === "DELIVERY" && { orderSource: "b2c" }),
                    });
                }
              }
            })
            .catch(() => {
              setNewLoader(false);
            });
        } else {
          // ✅ FIXED: Non-split CASH payment handling
          setNewId(orderId);

          if (adjustCheck && orderId) {
            const previousOrderId = localStorage.getItem("OrderId");
            const metaData = {
              previousOrderId: previousOrderId,
              newOrderId: orderId,
              approvedByName: selectedManager?.label,
              approvedBy: selectedManager?.uidx,
            };
            eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
          }

          // ✅ Instead of navigating away, show success in modal
          setNewLoader(false);
          setModalLoader(false);
          setpaymentLoader(true);
          setPaymentSuccess(true);
          orderMetricsApiCall();

          // Print receipt for delivery/takeaway
          if (
            (branchSubType === "FINE_DINE" &&
              (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) ||
            branchSubType !== "FINE_DINE"
          ) {
            shouldAutoPrintForPayment &&
              startPrint({
                orderId: orderId,
                skipBill: qsrSkipBill,
                skipKot: qsrSkipKot,
                ...(saleMode === "DELIVERY" && { orderSource: "b2c" }),
              });
          }

          // Don't navigate - keep the payment modal open showing success
          setSplitActive(false);
          setPartailStatus(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setIsButtonDisabled(false);
        setNewLoader(false);
        setIsPlacingDelivery(false);
      });
  };

  const createDebitFun = async () => {
    setModalLoader(true);
    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    // Check if printer agent is online for this location
    const SEND_TO_KITCHEN_KEY = "sendToKitchen";
    let sendToKitchenEnabled = false;
    try {
      sendToKitchenEnabled = localStorage.getItem(SEND_TO_KITCHEN_KEY) === "true";
    } catch {
      sendToKitchenEnabled = false;
    }

    // Determine if sendToKitchen should be included
    const shouldSendToKitchen =
      branchSubType === "FINE_DINE" &&
      (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY") &&
      sendToKitchenEnabled;

    const shouldKDS =
      isKDSRequired && branchSubType === "FINE_DINE"
        ? saleMode === "DELIVERY" || saleMode === "TAKE_AWAY"
        : saleMode === "DELIVERY" || saleMode === "TAKE_AWAY" || saleMode === "DINE_IN";

    let cart_ID = localStorage.getItem("CartId");
    const isWhatsapp = JSON.parse(localStorage.getItem("customer_details"))?.whatsapp;
    // const change = Math.round(Number(amtToBePaid));
    let createOrderPayload = {
      sessionId: sessionId,
      licenseId: licenseId,
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      licenseName: licenseName,
      machineCode: "CASH",
      cartId: cart_ID,
      paymentMode: storeMode === "OFFLINE" ? "OFFLINE" : "ONLINE",
      paymentMethod: saleMode === "delivery" ? "COD" : paymentMethod,
      inventoryCheck: "NO",
      tender: enterAmount,
      paymentType: "POS_CREDIT_SALE",
      currentUserName: firstName,
      balance:
        paymentMethod === "DEBIT_NOTE" ? "0" : String(Math.abs(Math.round(Number(amtToBePaid)))),
      whatsapp: isWhatsapp,
      ...(paymentMethod === "DEBIT_NOTE" && { subOrderType: "POS_CREDIT_SALE" }),
      amount: paymentMethod === "DEBIT_NOTE" ? Number(amtToBePaid) : Math.round(amtToBePaid),
      orderedBy: uidx,
      orderedByName: retailUserName,
      ...(shouldSendToKitchen && { isPrintNeeded: true }),
      ...(shouldKDS && { isSendToKitchen: true }),
      ...(orderBumpingMode === "AUTO" ? { isAutoAccepted: true } : { isAutoAccepted: false }),
    };
    customEventTrigger(`pos_payment_method`, {
      payment_method: `selected_method_${paymentMethod}`,
    });
    await CreateRestaurantOrder(createOrderPayload)
      .then((res) => {
        if (!!res?.data?.data?.es) {
          showSnackbar(
            res?.data?.data?.message || "Something went wrong. Please try again.",
            "error"
          );

          return;
        }
        let orderId = res?.data?.data?.orderResponseModel?.orderId;
        if (splitActive) {
          getOrderDetails(orderId, locId)
            .then((res) => {
              if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PARTIALLY_PAID") {
                showSnackbar(res?.data?.data?.baseOrderResponse?.orderStatus, "success");
                setEnterAmount("");
                setAmountPaid(res?.data?.data?.baseOrderResponse?.amountPaid);
                setAmountDue(res?.data?.data?.baseOrderResponse?.outstandingAmount);
                setNewId(res?.data?.data?.baseOrderResponse?.orderId);
                setPartailStatus(true);
                setNewLoader(false);
              } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "COMPLETED") {
                setIsPlacingDelivery(false);
                closePaymentModal();
                resetValues();
                // Open customer modal for TAKE_AWAY, DELIVERY, or QSR DINE_IN
                if (
                  saleMode === "TAKE_AWAY" ||
                  saleMode === "DELIVERY" ||
                  (saleMode === "DINE_IN" && branchSubType !== "FINE_DINE")
                ) {
                  setOpenCartCustomerDetail(true);
                }
                navigate("/order-completed", { state: { orderId: orderId, change: change } });
                setNewLoader(false);
                setPartailStatus(false);
                setSplitActive(false);
              }
            })
            .catch(() => {
              setNewLoader(false);
            });
        } else {
          setNewId(orderId);
          if (adjustCheck && orderId) {
            const previousOrderId = localStorage.getItem("OrderId");
            const metaData = {
              previousOrderId: previousOrderId,
              newOrderId: orderId,
              approvedByName: selectedManager?.label,
              approvedBy: selectedManager?.uidx,
            };

            eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
          }
          setModalLoader(false);
          setpaymentLoader(true);
          setPaymentSuccess(true);
          orderMetricsApiCall();
          if (
            (branchSubType === "FINE_DINE" &&
              (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) ||
            branchSubType !== "FINE_DINE"
          ) {
            shouldAutoPrintForPayment &&
              startPrint({
                orderId: orderId,
                skipBill: qsrSkipBill,
                skipKot: qsrSkipKot,
                ...(saleMode === "DELIVERY" && { orderSource: "b2c" }),
              });
          } else {
            // openDrawer();
            if (paymentMethod === "CASH") {
              openDrawer();
            }
          }
          resetValues();
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setPaymentFailed(true);
        setModalLoader(false);
        setPaymentSuccess(false);
      });
  };

  const checkPayment = () => {
    if ((isBillPrinted && printedBillOrderId) || cartStatus === "ORDER_CREATED") {
      setNewId(printedBillOrderId);
      partialCompletePayment();
      return;
    }
    switch (paymentMethod) {
      case "CASH":
        createOrderFun();
        break;
      case "UPI":
      case "SODEXO":
      case "CARD":
        digitalPaymentFunUPI();
        break;
      case "DEBIT_NOTE":
        createDebitFun();
        break;
      default:
        break;
    }
  };

  const orderMetricsApiCall = () => {
    if (!isMobile) {
      let totalDiff = 0;

      for (let i = 0; i < productTimeArray.length; i++) {
        totalDiff += productTimeArray[i];
      }

      const averageDiff = totalDiff / productTimeArray.length;
      const currentTime = new Date().getTime();
      const orderTime = currentTime - eventTime.startTime;
      const payload = {
        sessionId: sessionId,
        dayId: daySessionId,
        uidx: uidx,
        manualSearchCount: manuallyAddedProducts,
        barCodeSearchCount: scannedProducts,
        totalItems: totalProducts,
        averageItemTime: averageDiff,
        orderTime: orderTime,
        itemsRemoved: manuallyRemovedItems,
        manualItems: manuallyAddedGtinArray,
      };
      orderMetricsCreate(payload).then((res) => console.log(res));
      dispatch(resetState(0));
      localStorage.setItem("orderMetrics", JSON.stringify({}));
    }
  };

  const callGetOrder = (orderId, currentRetry) => {
    setPaymentSuccess(false);
    let maxRetries = 95;
    let retry = currentRetry || 0;
    orderStatusRetry(orderId)
      .then((res) => {
        if (
          res?.data?.data?.baseOrderResponse?.paymentStatus === "PAYMENT_PENDING" &&
          retry < maxRetries &&
          res?.data?.data?.baseOrderResponse?.orderStatus === "CREATED"
        ) {
          retry++;
          setPartailStatus(true);
          showSnackbar(res?.data?.data?.baseOrderResponse?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setTimeout(() => callGetOrder(orderId, retry), 2000 + retry);
        } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PAYMENT_CANCELLED") {
          setpaymentLoader(false);
          return;
        } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "CANCELLED") {
          setpaymentLoader(false);
          return;
        } else if (res?.data?.data?.baseOrderResponse?.paymentStatus === "PARTIALLY_PAID") {
          setPaymentLoadingModal(false);
          showSnackbar(res?.data?.data?.baseOrderResponse?.paymentStatus, "success");
          setAmountPaid(res?.data?.data?.baseOrderResponse?.amountPaid);
          setAmountDue(res?.data?.data?.baseOrderResponse?.outstandingAmount);
          setOrderId(res?.data?.data?.baseOrderResponse?.orderId);
          setPartailStatus(true);
          setEnterAmount("");
          if (splitActive) {
            setPaymentSuccess(false);
            setpaymentLoader(false);
          }
        } else {
          if (retry === maxRetries) {
            setPaymentFailed(true);
          } else if (res?.data?.data?.baseOrderResponse?.orderStatus === "PAYMENT_PENDING") {
            setPaymentLoadingModal(false);
          } else {
            setPaymentFailed(false);
            setPaymentSuccess(true);

            if (
              (branchSubType === "FINE_DINE" &&
                (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) ||
              branchSubType !== "FINE_DINE"
            ) {
              shouldAutoPrintForPayment &&
                startPrint({
                  orderId: orderId,
                  skipBill: qsrSkipBill,
                  skipKot: qsrSkipKot,
                  ...(saleMode === "DELIVERY" && { orderSource: "b2c" }),
                });
            } else {
              // openDrawer();
              if (paymentMethod === "CASH") {
                openDrawer();
              }
            }
            if (adjustCheck && orderId) {
              const previousOrderId = localStorage.getItem("OrderId");
              const metaData = {
                previousOrderId: previousOrderId,
                newOrderId: orderId,
                approvedByName: selectedManager?.label,
                approvedBy: selectedManager?.uidx,
              };

              eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
            }
            orderMetricsApiCall();
            showSnackbar("Payment Success", "success");
          }
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const partialCompletePayment = () => {
    const targetOrderId = isBillPrinted ? printedBillOrderId : newId;
    // const targetOrderId = null;

    // Validate orderId before proceeding
    if (!targetOrderId) {
      const fallbackOrderId = localStorage.getItem("OrderId");
      if (!fallbackOrderId) {
        showSnackbar("Order is created. Please select a table to complete the payment.", "error");
        setCancelLoader(false);
        setPaymentLoadingModal(false);
        closePaymentModal();
        navigate("/products/table-layout");
        return;
      }
      // Use fallback and update state
      setNewId(fallbackOrderId);
    }

    customEventTrigger("pos_partial_payment");

    // Apply rounding to all amounts
    const roundedEnterAmount = calculateRoundedAmount(enterAmount);
    const roundedAmountDue = calculateRoundedAmount(amountDue);
    const roundedAmtToBePaid = calculateRoundedAmount(amtToBePaid);
    const roundedTotal = calculateRoundedAmount(total);

    if ((roundedEnterAmount === "" || roundedEnterAmount < 0) && paymentMethod === "CASH") {
      showSnackbar("Please enter a valid amount", "error");
      return;
    }
    if (
      (roundedEnterAmount === 0 || roundedEnterAmount === "" || roundedEnterAmount < 1) &&
      splitActive
    ) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    setCancelLoader(false);
    setPayLoader(true);
    const machineId = localStorage.getItem("machineId");
    const change = adjustCheck
      ? (Number(roundedEnterAmount) - Number(roundedAmountDue || roundedAmtToBePaid)).toFixed(2)
      : (Number(roundedEnterAmount) - Number(roundedAmountDue || roundedTotal)).toFixed(2);

    let payload = {
      orderId: targetOrderId || localStorage.getItem("OrderId"),
      ...(splitActive && { paymentType: "SPLIT" }),
      ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
      ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      amount: splitActive || paymentMethod === "CASH" ? roundedEnterAmount : roundedTotal,
      paymentMethod: paymentMethod,
      paymentMode: singleOrderoffline
        ? "OFFLINE"
        : storeMode === "OFFLINE" || !machineId
        ? "OFFLINE"
        : "ONLINE",
      licenseId: licenseId,
      sessionId: sessionId,
      loggedInUserId: uidx,
      machineCode: machineId,
      tender: roundedEnterAmount,
      balance: String(Math.abs(change)),
    };

    return payOrderSplit(payload)
      .then((res) => {
        setPaymentLoadingModal(true);
        if (res?.data?.data?.es === 1) {
          showSnackbar(res?.data?.data?.message, "error");
        }

        if (res?.data?.data?.paymentStatus === "COMPLETED") {
          setPaymentFailed(false);
          setPaymentSuccess(true);
          setpaymentLoader(true);
          if (
            (branchSubType === "FINE_DINE" &&
              (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) ||
            branchSubType !== "FINE_DINE"
          ) {
            shouldAutoPrintForPayment &&
              startPrint({
                orderId: newId,
                skipBill: qsrSkipBill,
                skipKot: qsrSkipKot,
                ...(saleMode === "DELIVERY" && { orderSource: "b2c" }),
              });
          } else {
            // openDrawer();
            if (paymentMethod === "CASH") {
              // openDrawer();
            }
          }

          if (adjustCheck && orderId) {
            const previousOrderId = localStorage.getItem("OrderId");
            const metaData = {
              previousOrderId: previousOrderId,
              newOrderId: orderId,
              approvedByName: selectedManager?.label,
              approvedBy: selectedManager?.uidx,
            };

            eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_EDITED });
          }
          orderMetricsApiCall();
          showSnackbar("Payment Success", "success");
        } else if (
          res?.data?.data?.paymentStatus === "PARTIALLY_PAID" ||
          res?.data?.data?.paymentStatus === "PAYMENT_PENDING" ||
          res?.data?.data?.paymentStatus === "PAYMENT_CANCELLED"
        ) {
          if (
            (paymentMethod === "CARD" || paymentMethod === "UPI" || paymentMethod === "SODEXO") &&
            storeMode === "ONLINE"
          ) {
            setPaymentLoadingModal(true);
            setNewTransId(res?.data?.data?.transactionCode);
            callPaymentStatus(res?.data?.data?.transactionCode);
          }
          if (storeMode === "OFFLINE") callGetOrder(res?.data?.data?.orderId);
          setPaymentLoadingModal(false);
          setCashChange(true);
          showSnackbar(res?.data?.data?.orderStatus, "success");
          setEnterAmount("");
          setAmountPaid(res?.data?.data?.amountPaid);
          setAmountDue(res?.data?.data?.amountToBePaid);
          setPayLoader(false);
        } else {
          setPayLoader(false);
          setPaymentLoadingModal(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setPayLoader(false);
        setCashChange(false);
      });
  };

  const handlesplitInputChange = (e) => {
    const valueInput = e.target.value;
    setEnterAmount(valueInput);
  };

  const clrAmountFun = () => setEnterAmount("");

  const handleSplitPayment = () => {
    setPaymentMethod("CASH");
    setSplitActive(true);
  };

  const handleOffline = () => {
    setSingleOrderOffline(true);
  };

  const closePaymentModal = useCallback(
    (skipChargeCleanup = false) => {
      setOpenPayModal(false);
      setCancelledOnce(false);

      // If modal closed without completing payment, go back to Print Bill phase
      // so user sees "Reprint bill" + "Payment" instead of the "Pay" button
      if (skipChargeCleanup !== true) {
        setShowFineDineActionButtons(false);
      }

      // Remove delivery/packing charges if modal closed without payment
      // Note: skipChargeCleanup must be strictly true (not a click event) to skip
      if (skipChargeCleanup !== true && (saleMode === "DELIVERY" || saleMode === "TAKE_AWAY")) {
        const _cartId = localStorage.getItem("CartId");
        const _retailUser = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
        const _userName = localStorage.getItem("user_name");
        restaurantCartUpdate({
          cartId: _cartId || "",
          deliveryCharges: 0,
          packingCharges: 0,
          updatedBy: _retailUser?.uidx || "",
          updatedByName: _userName || "",
          updatedBy: retailUserDetails?.uidx || "",
          sourceLocationId: locId,
          orderType: retailType === "RESTAURANT" ? "RESTAURANT_ORDER" : "POS_ORDER",
          destinationLocationId: locId,
          loggedInUser: retailUserDetails?.uidx || "",
        })
          .then((res) => {
            setDeliveryCharge(res?.data?.data?.data?.billing?.deliveryCharges || 0);
            setPackingCharge(res?.data?.data?.data?.billing?.packingCharges || 0);
            setTotal(res?.data?.data?.data?.billing?.totalCartValue);
            setTotalTaxes(res?.data?.data?.data?.billing?.tax);
            showSnackbar("Extra charges removed", "success");
          })
          .catch(() => {});
      }

      const current = new URLSearchParams(window.location.search);
      current.delete("modal");

      navigate(
        {
          pathname: "/restaurant/cart",
          search: current.toString(),
        },
        { replace: true }
      );
    },
    [splitActive, partialStatus, saleMode]
  );

  const handleCouponModal = useCallback(() => {
    customEventTrigger("pos_coupons_screen");
    setCouponsModal(true);
    setShowCoupon(true);
    setShowOfferApplied(false);
  }, [showCoupon, showLoyalty, showOfferApplied]);

  const handleDiscountDrawerClose = useCallback(() => {
    setDiscountDrawerOpen(false);
  }, []);

  useEffect(() => {
    if (!cartId) {
      setAppliedDiscountAmt(0);
      setAppliedDiscountType("NONE");
    }
    // Cart data (including discount state) is already fetched by the effect above (line ~791).
    // No separate fetch needed here — prevents duplicate API calls on every cartId change.
  }, [cartId]);

  const removeOrderLevelDiscount = useCallback(
    (targetCartId = cartId, options = {}) => {
      const {
        successMessage = "Discount removed successfully",
        errorMessage = "Unable to remove discount",
        silentSuccess = false,
      } = options;

      const appliedBy = retailUserDetails?.uidx || "";
      const appliedByName =
        [retailUserDetails?.firstName, retailUserDetails?.secondName].filter(Boolean).join(" ") ||
        "";

      const payload = {
        cartId: targetCartId,
        discountType: "NONE",
        discount: 0,
        appliedBy,
        appliedByName,
      };

      return applyOrderLevelDiscount(payload).then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.es > 0
        ) {
          throw new Error(res?.data?.data?.message || res?.data?.message || errorMessage);
        }

        const updatedCartData =
          res?.data?.data?.data || res?.data?.data?.cartData || res?.data?.data || null;

        syncCartDiscountState(updatedCartData);

        if (!silentSuccess && successMessage) {
          showSnackbar(successMessage, "success");
        }

        return updatedCartData;
      });
    },
    [
      cartId,
      retailUserDetails?.firstName,
      retailUserDetails?.secondName,
      retailUserDetails?.uidx,
      showSnackbar,
      syncCartDiscountState,
    ]
  );

  const removeDiscountAfterCartChange = useCallback(
    (cartData, shouldRemoveDiscount) => {
      if (!shouldRemoveDiscount) return;

      removeOrderLevelDiscount(cartData?.cartId || cartId, {
        silentSuccess: true,
      }).catch((err) => {
        showSnackbar(
          err?.response?.data?.data?.message ||
            err?.response?.data?.message ||
            err?.message ||
            "Unable to remove discount",
          "error"
        );
      });
    },
    [cartId, removeOrderLevelDiscount, showSnackbar]
  );

  const handleApplyDiscount = useCallback(
    ({ discountType, discount }) => {
      const runApplyDiscount = () => {
        setDiscountApplyLoader(true);

        const payload = {
          cartId: cartId || localStorage.getItem("CartId") || "",
          discountType,
          discount: Number(discount) || 0,
          appliedBy: selectedManagerRef.current?.uidx || retailUserDetails?.uidx || "",
          appliedByName: selectedManagerRef.current?.label || retailUserName || "",
        };

        applyOrderLevelDiscount(payload)
          .then((res) => {
            const cartData = res?.data?.data?.data;
            if (
              res?.data?.status === "ERROR" ||
              res?.data?.data?.status === "ERROR" ||
              res?.data?.data?.es > 0
            ) {
              showSnackbar(
                res?.data?.data?.message || res?.data?.message || "Unable to apply discount",
                "error"
              );
              return;
            }

            syncCartDiscountState(cartData);
            handleDiscountDrawerClose();
            showSnackbar("Discount applied successfully", "success");
          })
          .catch((err) => {
            showSnackbar(
              err?.response?.data?.message || err?.message || "Unable to apply discount",
              "error"
            );
          })
          .finally(() => {
            setDiscountApplyLoader(false);
          });
      };

      openAuthModal(runApplyDiscount);
    },
    [
      cartId,
      openAuthModal,
      retailUserDetails?.uidx,
      retailUserName,
      showSnackbar,
      syncCartDiscountState,
      handleDiscountDrawerClose,
    ]
  );

  const handleRemoveDiscount = useCallback(() => {
    setDiscountApplyLoader(true);

    applyOrderLevelDiscount({
      cartId: cartId || localStorage.getItem("CartId") || "",
      discountType: "NONE",
      discount: 0,
      appliedBy: retailUserDetails?.uidx || "",
      appliedByName: retailUserName || "",
    })
      .then((res) => {
        const cartData = res?.data?.data?.data;
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.es > 0
        ) {
          showSnackbar(
            res?.data?.data?.message || res?.data?.message || "Unable to remove discount",
            "error"
          );
          return;
        }

        syncCartDiscountState(cartData);
        showSnackbar("Discount removed successfully", "success");
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || err?.message || "Unable to remove discount",
          "error"
        );
      })
      .finally(() => {
        setDiscountApplyLoader(false);
      });
  }, [cartId, retailUserDetails?.uidx, retailUserName, showSnackbar, syncCartDiscountState]);

  const handleLoyaltyModal = useCallback(() => {
    customEventTrigger("pos_loyalty_screen");
    setLoyaltyModal(true);
    setShowLoyalty(true);
    setShowOfferApplied(false);
  }, [showLoyalty, showCoupon, showOfferApplied]);

  const handleOfferModalClose = useCallback(() => setOfferModal(false), []);

  const handleOfferModalOpen = useCallback(() => {
    customEventTrigger("pos_offer_screen");
    setOfferModal(true);
    setShowLoyalty(false);
    setLoyaltyModal(false);
    setCouponsModal(false);
    setShowCoupon(false);
  }, [showLoyalty, showCoupon, showOfferApplied]);

  const debouncedApiCall = useRef(
    debounce((payload, notes) => {
      restaurantCreateCart(payload)
        .then((res) => {
          if (
            res?.data?.data?.es > 0 ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.status === "ERROR"
          ) {
            showSnackbar(res?.data?.data?.message || "Unable to save notes", "error");
            setNoteFromCustLoader(false);
            return;
          }
          if (notes?.length > 0) {
            showSnackbar("Note successfully saved", "success");
            setNoteFromCustLoader(false);
          } else {
            showSnackbar("Note successfully removed", "success");
            setNoteFromCustLoader(false);
          }
        })
        .catch((err) => {
          showSnackbar(
            err?.response?.data?.message || err?.message || "Unabl to save notes",
            "error"
          );
          setNoteFromCustLoader(false);
        });
    }, 700)
  );

  const handleComments = (e) => {
    //storing notes in state
    setNoteFromCustLoader(true);
    const notes = e.target.value;
    setComments(notes);

    let tableNumber;
    let tableId;

    if (branchSubType === "FINE_DINE") {
      if (saleMode === "DINE_IN") {
        tableNumber = selectedTable?.tableMetadata?.tableName;
        tableId = selectedTable?.tableMetadata?.tableMetadataId;
      } else if (saleMode === "TAKE_AWAY") {
        tableNumber = "1";
        tableId = "TAKEAWAY";
      } else {
        tableNumber = "1";
        tableId = "DELIVERY";
      }
    } else {
      tableNumber = "1";
      tableId = "1";
    }

    if (retailType === "RESTAURANT") {
      // Set subOrderType to QSR_DINE_IN for QSR branch with DINE_IN sale mode
      const subOrderType =
        branchSubType === "QSR" && saleMode === "DINE_IN" ? "QSR_DINE_IN" : saleMode;

      const payload = {
        cartId: cartId,
        locationId: locId,
        sourceLocationId: locId,
        orderType: "RESTAURANT_ORDER",
        loggedInUser: retailUserLocalStorageData?.uidx,
        destinationLocationId: locId || "",
        comments: notes || "",
        tableNumber: tableNumber,
        tableId: tableId,
        subOrderType: subOrderType,
      };

      debouncedApiCall.current(payload, notes);
    }
  };

  const offerNewSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-error",
      cancelButton: "button button-success",
      container: "close-session-swal-container",
    },
    buttonsStyling: false,
  });

  const handleOfferCalculate = () => {
    setOfferLoader(true);
    cartOfferCalculate(CartId)
      .then((response) => {
        const cartData = response?.data?.data?.cartData;
        const itemData = response?.data?.data?.data;
        setOfferFound(cartData?.offerProductFound);
        setCartItems(cartData?.cartProducts);
        setCartTotalQty(cartData?.billing?.quantity);
        setCartId(cartData?.cartId);
        setCgst(cartData?.billing?.cgst);
        setSgst(cartData?.billing?.sgst);
        setCess(cartData.billing.totalCessAmount);
        setSubTotal(getDisplayedItemTotal(cartData));
        setTotalTaxes(cartData?.billing?.tax);
        setTotalValue(cartData?.billing?.totalValue);
        setTotal(cartData?.billing?.totalCartValue);
        setContextCouponApplied?.(cartData?.billing?.appliedCoupon || "0");
        syncCouponUiState(cartData);
        setIsExploding(true);
        setOfferLoader(false);
        if (itemData.length < 1) {
          handleCloseOfferCheckModal();
          setOfferFound(false);
        }
        const offerList = itemData?.map((ele) => {
          return {
            productName: ele?.cartProduct?.productName,
            productGtin: ele?.cartProduct?.gtin,
            productBatchNo: ele?.cartProduct?.batchNo,
            productMrp: ele?.cartProduct?.mrp,
            productSp: ele?.cartProduct?.sellingPrice,
            availableOfferList: ele?.inventoryResponse?.offersEntityList,
          };
        });
        setOfferListData(offerList);
        if (offerList.length > 0) {
          offerNewSwal
            .fire({
              title: "Offer Found",
              text: `There ${offerList.length === 1 ? "is" : "are"} ${offerList.length} ${
                offerList.length === 1 ? "item" : "items"
              } in your cart which doesn't meet the offer criteria. Would you like to know more about it ?`,
              icon: "info",
              showCancelButton: true,
              cancelButtonText: "Show the Offers",
              confirmButtonText: "Proceed without offer",
              preConfirm: async () => {
                handleCloseOfferCheckModal();
                setOfferFound(false);
              },
              backdrop: "rgba(0,0,0,0.4)",
            })
            .then((result) => {
              if (result.dismiss === "cancel") {
                handleShowoffer();
              }
            });
        }
      })
      .catch((err) => {
        showSnackbar(err.message || err?.response?.data?.message, "error");
      });
  };

  const handleShowoffer = () => {
    setShowOffer(true);
    handleOpenOfferCheckModal();
  };

  const calculateRoundedAmount = (amount) => {
    if (!forceRoundOffEnabled || amount === undefined || amount === null || amount === "")
      return amount;
    return applyRoundOff(amount, roundOffFloorValue);
  };

  useEffect(() => {
    let amount = total - pAMt;
    const roundedAmount = forceRoundOffEnabled
      ? Math.abs(applyRoundOff(amount, roundOffFloorValue))
      : Math.abs(amount).toFixed(2);
    setAmtToBePaid(roundedAmount);

    if (amount > 0) {
      setAmtHeading("Payable Amount");
    } else {
      setAmtHeading("Recievable Amount");
    }
  }, [total, pAMt, forceRoundOffEnabled]);

  const activeKeys = useRef(new Set());

  const cartRightContainerRef = useRef(null);
  const focusedCartItemIndexRef = useRef(-1);
  const cartItemsRef = useRef([]);
  const cartKeyboardFnRefs = useRef({});
  const focusedCartItemRef = useRef(null);
  const [grossBarLeft, setGrossBarLeft] = useState(0);
  const [grossBarWidth, setGrossBarWidth] = useState(0);

  useEffect(() => {
    const updateGrossBarPosition = () => {
      if (cartRightContainerRef.current) {
        const rect = cartRightContainerRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const isPosTabletWidth = viewportWidth >= 1024 && viewportWidth <= 1100;
        const useFineDineTabletFooter =
          isPosTabletWidth && branchSubType === "FINE_DINE" && saleMode === "DINE_IN";
        const targetWidth = useFineDineTabletFooter ? 408 : rect.width;
        const targetLeft = useFineDineTabletFooter
          ? Math.max(0, rect.right - targetWidth)
          : rect.left;

        setGrossBarLeft(targetLeft);
        setGrossBarWidth(targetWidth);
      }
    };

    updateGrossBarPosition();

    const resizeObserver =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(updateGrossBarPosition) : null;

    if (cartRightContainerRef.current && resizeObserver) {
      resizeObserver.observe(cartRightContainerRef.current);
    }

    window.addEventListener("resize", updateGrossBarPosition);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", updateGrossBarPosition);
    };
  }, [branchSubType, saleMode]);

  useEffect(() => {
    setCartGrossBarVisible?.(!openCartCustomerDetail);
    return () => setCartGrossBarVisible?.(false);
  }, [openCartCustomerDetail, setCartGrossBarVisible]);

  useEffect(() => {
    if (focusedCartItemIndex >= 0 && focusedCartItemRef.current) {
      focusedCartItemRef.current.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, [focusedCartItemIndex]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (activeKeys?.current.has(e?.key)) {
        return;
      }

      activeKeys?.current.add(e?.key);

      if (e?.key === "F1") {
        e.preventDefault();

        if (branchSubType !== "FINE_DINE") {
          let isProductsAvailable = true;

          for (const item of cartItems) {
            if (item?.inventoryStatus === "OUT_OF_STOCK") {
              isProductsAvailable = false;
              break;
            }
          }

          if (!isProductsAvailable) return;

          handleOpenPaymentModal();
        }
      }

      if (e?.key === "F4") {
        e.preventDefault();
        handleNewCart();
      }

      if (e?.key === "F6") {
        e.preventDefault();
        const holdVisible = branchSubType === "FINE_DINE" ? saleMode !== "DINE_IN" : true;
        if (holdVisible) {
          if (cartItems.length < 1) {
            showSnackbar("Add products to the cart to hold.", "info");
          } else {
            setHoldCartModalOpen(true);
          }
        }
      }

      if (e?.key === "F7") {
        e.preventDefault();
        deleteCartItem();
      }

      if (e?.key === "F8") {
        e.preventDefault();
        handleLoyaltyModal();
      }

      if (e?.key === "F9") {
        e.preventDefault();
        handleCouponModal();
      }

      if (e?.key === "F10") {
        e.preventDefault();
        handleOfferModalOpen();
      }

      if (e?.key === "F11") {
        e.preventDefault();
        setNoteModalOpen((prev) => !prev);
      }
    };

    const handleKeyup = (e) => {
      activeKeys.current.delete(e.key);
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyup);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyup);
    };
  }, [
    handleOpenPaymentModal,
    handleNewCart,
    deleteCartItem,
    openPayModal,
    checkPayment,
    paymentMethod,
    enterAmount,
  ]);

  const handleTableReservation = (skipKot = false) => {
    setPlaceOrderLoader(skipKot ? "skipKot" : "place");
    const SEND_TO_KITCHEN_KEY = "sendToKitchen";

    // Check if printer agent is online for this location
    let sendToKitchenEnabled = false;
    try {
      sendToKitchenEnabled = localStorage.getItem(SEND_TO_KITCHEN_KEY) === "true";
    } catch {
      sendToKitchenEnabled = false;
    }
    const shouldKDSAndPrint = sendToKitchenEnabled || isKDSRequired;
    // Build payload - only include sendToKitchen: true if printer agent is online
    const payload = {
      cartId: CartId,
      sentBy: retailUserLocalStorageData?.uidx,
      sentByName: retailUserLocalStorageData?.firstName,
      ...(shouldKDSAndPrint && { sendToKitchen: true }),
      isPrintNeeded: sendToKitchenEnabled && !skipKot ? true : false,
      ...(orderBumpingMode === "AUTO" ? { isAutoAccepted: true } : { isAutoAccepted: false }),
    };

    sendToKDS(payload)
      .then((res) => {
        if (
          res?.data?.data?.es > 0 ||
          res?.data?.data?.data?.es > 0 ||
          res?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          setPlaceOrderLoader(false);
          showSnackbar(res?.data?.data?.message || "Unable to place order", "error");
          return;
        }
        const currentSequence = res?.data?.data?.data?.currentPlacedSequence;
        setLastPlacedSequence(currentSequence);
        const tokenPayload = {
          cartId: CartId,
          orderSequence: currentSequence,
          generatedBy: retailUserLocalStorageData?.uidx,
          generatedByName: retailUserLocalStorageData?.firstName,
        };

        {
          !sendToKitchenEnabled &&
            !skipKot &&
            getToken(tokenPayload).then((res) => {
              // Only print from UI if this is NOT the main printer device
              if (!sendToKitchenEnabled) {
                printToken({
                  tableId: res?.data?.data?.data?.tableId,
                  tokenNumber: res?.data?.data?.data?.tokenNumber,
                  tableNumber: res?.data?.data?.data?.tableNumber,
                  subOrderType: res?.data?.data?.data?.subOrderType,
                  customerName: customerName || "Walk-in Customer",
                  orderItems: res?.data?.data?.data?.orderedProducts,
                  comments: res?.data?.data?.data?.comments || "N/A",
                  layoutName: res?.data?.data?.data?.layoutName,
                })
                  .then(() => {
                    showSnackbar("Token printed successfully", "success");
                  })
                  .catch((printError) => {
                    showSnackbar("Order placed but token printing failed", "warning");
                  });
              }
            });
        }
        showSnackbar("Order Placed Successfully", "success");
        navigate("/products/table-layout");
        setPlaceOrderLoader(false);
      })
      .catch((err) => {
        setPlaceOrderLoader(false);
        // On error, fall back to UI printing
        showSnackbar("Error placing order", "error");
      });
  };

  const groupedCartItems = useMemo(() => {
    if (retailType !== "RESTAURANT") return null;

    const grouped = {};
    cartItems?.forEach((item) => {
      const sequence = item.placedSequence;
      if (!grouped[sequence]) {
        grouped[sequence] = [];
      }
      grouped[sequence].push(item);
    });

    return Object.keys(grouped)
      .sort((a, b) => {
        // Handle null/undefined/NaN sequences - put them at the top (new orders)
        const seqA = Number(a);
        const seqB = Number(b);
        const isANew = isNaN(seqA) || a === "null" || a === "undefined";
        const isBNew = isNaN(seqB) || b === "null" || b === "undefined";

        if (isANew && !isBNew) return -1; // A is new, put it first
        if (!isANew && isBNew) return 1; // B is new, put it first
        if (isANew && isBNew) return 0; // Both are new

        return seqB - seqA; // Higher sequence (newer) first
      })
      .map((sequence) => ({
        sequence: sequence === "null" || sequence === "undefined" ? null : Number(sequence),
        items: grouped[sequence],
      }));
  }, [cartItems]);

  // ENHANCED: handleTableRelease - updates cache in localStorage when table is released
  const handleTableRelease = (action) => {
    if (action === "release") {
      setTableReleaseLoader(true);
      const placedOrderItem = cartItems?.find(
        (item) => item?.productStatus === "REQUESTED_TO_KITCHEN" || item?.productStatus === "SERVED"
      );
      if (placedOrderItem) {
        showSnackbar(
          "Unable to release the table as the order has already been placed.",
          "warning"
        );
        setTableReleaseLoader(false);
        return;
      }
    }

    fetchTableBookingStatus(orgId, locId, "CHECKED_IN")
      .then((res) => {
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.message || "Unable to fetch booking status", "error");
          setTableReleaseLoader(false);
          return;
        }
        const bookingStatus = res?.data?.reservations;
        setTableBookingStatus(bookingStatus);
        const tableToRelease = bookingStatus?.filter(
          (booking) => booking?.mapId === selectedTable?.mapId
        );
        if (action === "checkedout") {
          return;
        } else {
          manualTableCancellation(tableToRelease[0]?.slotId)
            .then((res) => {
              if (
                res?.data?.es > 0 ||
                res?.data?.data?.es > 0 ||
                res?.data?.status === "ERROR" ||
                res?.data?.data?.status === "ERROR"
              ) {
                // showSnackbar(res?.data?.message || "Unable to cancel table reservation", "error");
                setTableReleaseLoader(false);
                return;
              }
              showSnackbar(res?.data?.message || "Table successfully canceled", "success");

              // CRITICAL: Update table status to AVAILABLE in localStorage cache
              try {
                // Get the layout ID from selectedTable or from stored floor/area info
                let layoutId = selectedTable?.layoutId;

                // If layoutId not in selectedTable, try to get it from stored selection
                if (!layoutId) {
                  const storedSelection = JSON.parse(
                    localStorage.getItem("restaurant_selected_floor_area")
                  );
                  layoutId = storedSelection?.area?.value;
                }

                // If we still don't have layoutId, try to find it from areas storage
                if (!layoutId && selectedTable?.mapId) {
                  const areasStorage = JSON.parse(localStorage.getItem("restaurant_areas"));
                  if (areasStorage) {
                    // Search through areas to find which one contains this table
                    Object.values(areasStorage).forEach((area) => {
                      // This is a simplified search - you may need to adjust based on your data structure
                      layoutId = area?.mapId;
                    });
                  }
                }

                if (layoutId) {
                  const cacheKey = `restaurant_tables_${layoutId}`;
                  const cachedData = localStorage.getItem(cacheKey);

                  if (cachedData) {
                    const tables = JSON.parse(cachedData);
                    const updatedTables = tables.map((table) => {
                      if (table?.mapId === selectedTable?.mapId) {
                        // Mark table as AVAILABLE and clear all status fields
                        return {
                          ...table,
                          status: "AVAILABLE",
                          cartStatus: null,
                          statusCartId: null,
                          statusOrderId: null,
                          totalCartValue: 0,
                          kitchenCount: 0,
                        };
                      }
                      return table;
                    });

                    // Save updated tables back to cache
                    localStorage.setItem(cacheKey, JSON.stringify(updatedTables));
                  }
                }
              } catch (error) {}

              const payload = {
                cartId: CartId,
                closedBy: retailUserLocalStorageData?.uidx,
                closedByName: retailUserLocalStorageData?.firstName,
                comments: "Cart closed because table released manually",
              };

              restaurantCartClose(payload)
                .then((res) => {
                  if (
                    res?.data?.data?.es > 0 ||
                    res?.data?.data?.data?.es > 0 ||
                    res?.data?.es > 0 ||
                    res?.data?.status === "ERROR" ||
                    res?.data?.data?.status === "ERROR"
                  ) {
                    showSnackbar("Unable to close cart", "error");
                    setTableReleaseLoader(false);
                    return;
                  }
                  // showSnackbar("Cart closed successfully", "success");
                  localStorage.removeItem("CartId");
                  setTableReleaseLoader(false);
                })
                .catch((err) => {
                  showSnackbar("Unable to close cart", "error");
                  setTableReleaseLoader(false);
                });
              navigate("/products/table-layout");
            })
            .catch((err) => {
              showSnackbar(err?.message || err || "Unable to cancel table reservation", "error");
              setTableReleaseLoader(false);
            });
        }
      })
      .catch((err) => {
        showSnackbar(err?.message || err || "Unable to fetch booking status", "error");
        setTableReleaseLoader(false);
      });
  };

  const handleTableActionButton = (actionButton) => {
    if (actionButton === "transfer") {
      if (isBillPrinted) {
        showSnackbar("Cannot transfer table after bill is printed", "error");
        return;
      }
      setTransferTableModalOpen(true);
      return;
    }
    if (actionButton === "release") {
      setTableConfirmationModalOpen(true);
    }
  };

  const handlePrintBill = async (skipPrint = false, openPayment = false) => {
    // Reprint only when the bill was already printed once (button shows "Reprint bill")
    const isReprint = isBillPrinted && !!printedBillOrderId;
    try {
      setPrintBillLoader(skipPrint ? "skipPrint" : "print");
      setPlaceOrderLoader(true);

      const billPayload = {
        sessionId: sessionId,
        licenseId: licenseId,
        cartId: cartId,
        paymentType: "SPLIT",
        paymentMethod: "CASH",
        paymentMode: "OFFLINE",
        inventoryCheck: "NO",
        amount: 0,
        tender: 0,
        balance: total,
        orderedBy: uidx,
        orderedByName: retailUserName,
        ...(orderBumpingMode === "AUTO" ? { isAutoAccepted: true } : { isAutoAccepted: false }),
        ...(roundOffEnabled && { roundOffCeil: roundOffCeilValue }),
        ...(roundOffEnabled && { roundOffFloor: roundOffFloorValue }),
      };

      const response = await CreateRestaurantOrder(billPayload);

      if (response?.data?.data?.orderResponseModel?.orderId) {
        const orderId = response.data.data.orderResponseModel.orderId;

        setPrintedBillOrderId(orderId);
        setIsBillPrinted(true);

        if (skipPrint) {
          setPrintBillLoader(false);
          showSnackbar("Order created successfully (print skipped)", "success");
          if (openPayment) handleOpenPaymentModal();
        } else {
          startPrint({
            orderId: orderId,
            reprint: isReprint,
            skipBill: false,
            skipKot: false,
            onPrintComplete: () => {
              setPrintBillLoader(false);
              showSnackbar("Bill printed successfully", "success");
            },
            onPrintError: () => {
              setPrintBillLoader(false);
              showSnackbar("Failed to print bill", "error");
            },
          });
        }
      } else {
        setPrintBillLoader(false);
        setPlaceOrderLoader(false);
        showSnackbar("Failed to create bill order", "error");
      }

      setPlaceOrderLoader(false);
    } catch (error) {
      setPrintBillLoader(false);
      setPlaceOrderLoader(false);
      showSnackbar("Failed to print bill", "error");
    }
  };

  // Sync refs for restaurant cart keyboard shortcuts (runs every render)
  focusedCartItemIndexRef.current = focusedCartItemIndex;
  cartItemsRef.current = cartItems || [];
  cartKeyboardFnRefs.current = {
    increaseItemQuantity,
    decreaseItemQuantity,
    handleTableReservation,
    handlePrintBill,
    showFineDineActionButtons,
    branchSubType,
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (retailType !== "RESTAURANT") return;

    const handleCartKeyDown = (e) => {
      const tag = document.activeElement?.tagName?.toLowerCase();
      if (tag === "input" || tag === "textarea") return;

      const items = cartItemsRef.current;
      const idx = focusedCartItemIndexRef.current;
      const fns = cartKeyboardFnRefs.current;

      // Escape: unfocus cart item
      if (e.key === "Escape" && idx >= 0) {
        e.preventDefault();
        setFocusedCartItemIndex(-1);
        return;
      }
      // Alt+↓: focus next cart item
      if (e.altKey && e.key === "ArrowDown") {
        e.preventDefault();
        setFocusedCartItemIndex((prev) => Math.min(prev + 1, items.length - 1));
        return;
      }
      // Alt+↑: focus previous cart item
      if (e.altKey && e.key === "ArrowUp") {
        e.preventDefault();
        setFocusedCartItemIndex((prev) => (prev <= 0 ? 0 : prev - 1));
        return;
      }
      // +/= : increase quantity of focused cart item
      if ((e.key === "+" || e.key === "=") && !e.altKey && !e.ctrlKey && idx >= 0 && items[idx]) {
        e.preventDefault();
        fns.increaseItemQuantity(items[idx], idx);
        return;
      }
      // - : decrease quantity of focused cart item
      if (e.key === "-" && !e.altKey && !e.ctrlKey && idx >= 0 && items[idx]) {
        e.preventDefault();
        fns.decreaseItemQuantity(items[idx], idx);
        return;
      }
      // F2: place order with KOT print (FINE_DINE only, before order created)
      if (
        e.key === "F2" &&
        !e.shiftKey &&
        fns.branchSubType === "FINE_DINE" &&
        !fns.showFineDineActionButtons
      ) {
        e.preventDefault();
        fns.handleTableReservation(false);
        return;
      }
      // Shift+F2: place order without KOT print (FINE_DINE only, before order created)
      if (
        e.key === "F2" &&
        e.shiftKey &&
        fns.branchSubType === "FINE_DINE" &&
        !fns.showFineDineActionButtons
      ) {
        e.preventDefault();
        fns.handleTableReservation(true);
        return;
      }
      // F5: print bill with print (FINE_DINE only, after order created)
      if (
        e.key === "F5" &&
        !e.shiftKey &&
        fns.branchSubType === "FINE_DINE" &&
        fns.showFineDineActionButtons
      ) {
        e.preventDefault();
        fns.handlePrintBill(false);
        return;
      }
      // Shift+F5: print bill without print (FINE_DINE only, after order created)
      if (
        e.key === "F5" &&
        e.shiftKey &&
        fns.branchSubType === "FINE_DINE" &&
        fns.showFineDineActionButtons
      ) {
        e.preventDefault();
        fns.handlePrintBill(true);
        return;
      }
    };

    document.addEventListener("keydown", handleCartKeyDown);
    return () => document.removeEventListener("keydown", handleCartKeyDown);
  }, []); // empty deps — reads from refs

  const handleAddMoreItems = () => {
    setPrintBillLoader(false);
    setShowFineDineActionButtons(false);
    setIsBillPrinted(false);
    setPrintedBillOrderId(null);
    setCartStatus(null);
  };

  const getTotalKOTs = () => {
    if (!Array.isArray(groupedCartItems)) {
      return { label: "0 KOTs", amount: 0 };
    }
    const kotGroups = getPlacedKotGroups(groupedCartItems);
    const amount = kotGroups.reduce((sum, g) => {
      return (
        sum +
        g.items.reduce((s, i) => {
          if (i?.productStatus === "RETURNED") return s;
          return s + parseFloat(i?.subTotal || 0);
        }, 0)
      );
    }, 0);
    return { label: `${kotGroups.length} KOTs`, amount };
  };

  useEffect(() => {
    if (groupedCartItems?.length) {
      setAccordionStates(Array(groupedCartItems.length).fill(true));
    }
  }, [groupedCartItems]);

  const handleAccordionToggle = (index) => {
    setAccordionStates((prev) => prev.map((state, i) => (i === index ? !state : state)));
  };

  const handleViewLess = () => {
    const areAllOpen = accordionStates?.every((isOpen) => isOpen);
    setAccordionStates(Array(accordionStates.length).fill(!areAllOpen));
  };

  const getButtonTitle = () => {
    const areAllClosed = accordionStates.every((isOpen) => !isOpen);
    return areAllClosed ? "View more" : "View less";
  };

  const handleAggViewToggle = () => {
    setIsOn(!isOn);
  };

  const handleComplimentary = () => {
    if (showFineDineActionButtons && branchSubType === "FINE_DINE") {
      showSnackbar("Cannot mark complimentary after billing. Please add more items", "warning");
      return;
    }

    if (!cartItems?.length) {
      showSnackbar("Please add the item first", "warning");
      return;
    }

    setComplimentaryProductList([...cartItems]);
    setComplimentaryMode((prev) => !prev);
  };

  const handleComplimentaryApi = () => {
    const shouldRemoveDiscountOnCartChange = appliedDiscountAmt > 0;
    setComplementaryButtonLoader(true);
    complimentaryCart(complimentaryProductPayload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0 ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.status === "error"
        ) {
          setComplementaryButtonLoader(false);
          showSnackbar(
            res?.data?.data?.message || "Unable to mark the product as complementary",
            "error"
          );
          return;
        }
        syncCartDiscountState(res?.data?.data?.data);
        if (retailType === "RESTAURANT") {
          if (res?.data?.data?.data?.subOrderType === "QSR_DINE_IN") {
            setSaleMode("DINE_IN");
          } else {
            setSaleMode(res?.data?.data?.data?.subOrderType || "DINE_IN");
          }
        } else {
          setSaleMode(res?.data?.data?.data?.subOrderType || "DINE_IN");
        }
        setCgst(res?.data?.data?.data?.billing?.cgst);
        setSgst(res?.data?.data?.data?.billing?.sgst);
        setCess(res?.data?.data?.data?.billing?.totalCessAmount);
        setAppliedDiscountAmt(getAppliedDiscountDetails(res?.data?.data?.data).amount);
        setAppliedDiscountType(getAppliedDiscountDetails(res?.data?.data?.data).type);
        setSubTotal(getDisplayedItemTotal(res?.data?.data?.data));
        setTotal(res?.data?.data?.data?.billing?.totalCartValue);
        setTotalValue(res?.data?.data?.data?.billing?.totalValue);
        setTotalTaxes(res?.data?.data?.data?.billing?.tax);
        setOfferFound(res?.data?.data?.data?.offerProductFound);
        setContextCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon || "0");
        syncCouponUiState(res?.data?.data?.data);
        removeDiscountAfterCartChange(res?.data?.data?.data, shouldRemoveDiscountOnCartChange);
        setCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon);
        showSnackbar("Complimentary Added Successfully", "success");
        setComplimentaryMode(false);
        setComplementaryButtonLoader(false);
      })
      .catch((err) => {
        showSnackbar(err?.message || err || "Unable to mark items complementary");
        setComplementaryButtonLoader(false);
      });
  };

  const handleComplimentaryCancel = () => {
    setmarkWholeCartComplimentary(false);
    setSelectedComplimentaryIds([]);
    setComplimentaryProductPayload({});
    setComplimentaryMode(false);
  };

  const handleItemComplimentary = (cartProductId, qty = 1) => {
    const payload = {
      locationId: locId,
      cartId: CartId,
      cartProducts: { [cartProductId]: qty },
      markWholeCart: false,
      updatedBy: retailUserLocalStorageData?.uidx,
      updatedByName: retailUserLocalStorageData?.firstName,
    };
    setComplimentaryProductPayload(payload);
    setComplementaryButtonLoader(true);
    complimentaryCart(payload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0 ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.status === "error"
        ) {
          showSnackbar(
            res?.data?.data?.message || "Unable to mark the product as complementary",
            "error"
          );
          return;
        }
        syncCartDiscountState(res?.data?.data?.data);
        if (retailType === "RESTAURANT") {
          if (res?.data?.data?.data?.subOrderType === "QSR_DINE_IN") {
            setSaleMode("DINE_IN");
          } else {
            setSaleMode(res?.data?.data?.data?.subOrderType);
          }
        } else {
          setSaleMode(res?.data?.data?.data?.subOrderType);
        }
        setCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon);
        showSnackbar("Complimentary added successfully", "success");
      })
      .catch((err) => {
        showSnackbar(err?.message || "Unable to mark item as complimentary", "error");
      })
      .finally(() => {
        setComplementaryButtonLoader(false);
        setComplimentaryProductPayload({});
      });
  };

  const handleRepeatOrderFromKot = async (cartProductId) => {
    const payload = {
      cartId: CartId,
      cartProductIds: [cartProductId],
      reorderedBy: retailUserLocalStorageData?.uidx,
      reorderedByName: retailUserLocalStorageData?.firstName,
    };
    const res = await repeatOrder(payload);
    const top = res?.data;
    const mid = top?.data;
    const inner = mid?.data;

    if (
      top?.es > 0 ||
      mid?.es > 0 ||
      inner?.es > 0 ||
      top?.status === "ERROR" ||
      mid?.status === "ERROR"
    ) {
      throw new Error(mid?.message || "Unable to repeat the order");
    }

    const { cartProducts, offerProductFound, billing } = inner || {};
    const { cgst, sgst, totalCessAmount, subtotal, tax, totalValue, totalCartValue } =
      billing || {};

    setCartItems(cartProducts);
    if (cartProducts?.[0]?.cartProductId) {
      setHighlightedCartProductId(cartProducts[0].cartProductId);
      setTimeout(() => setHighlightedCartProductId(null), 2000);
    }
    setOfferFound(offerProductFound);
    setCgst(cgst);
    setSgst(sgst);
    setCess(totalCessAmount);
    setSubTotal(subtotal);
    setTotalTaxes(tax);
    setTotalValue(totalValue);
    setTotal(totalCartValue);
  };

  useEffect(() => {
    if (cartStatus === "ORDER_CREATED") {
      setShowFineDineActionButtons(true);
      setIsBillPrinted(true);
    }
  }, [cartStatus]);

  const handleClearCart = () => {
    if (!cartItems || cartItems.length === 0) {
      showSnackbar("Your cart is already empty", "info");
      return;
    }

    // Get all cart product IDs from current cart items
    const cartProductIds = cartItems.map((item) => item.cartProductId);

    setdeleteLoader(true);

    const payload = {
      cartId: cartId,
      cartProductIds: cartProductIds,
      comments: "All items cleared from cart",
      updatedByUser: uidx,
    };

    // You'll need to import or create this API function
    deleteWholeCart(payload)
      .then((res) => {
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0 ||
          res?.data?.data?.status === "ERROR" ||
          res?.data?.data?.status === "error"
        ) {
          showSnackbar(res?.data?.data?.message || "Unable to clear cart items", "error");
          setdeleteLoader(false);
          return;
        }

        // Cart is empty now, so clear any stale "not available" block from the previous items
        setDisableProceed(false);

        // Track the event
        const totalItems = cartItems.reduce(
          (totalQuantity, item) => totalQuantity + item.quantity,
          0
        );
        const metaData = {
          cartId: cartId,
          itemsCount: totalItems,
          amount: total,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.CART_DELETED });

        // Reset event tracker state
        dispatch(resetStateWithoutTime(0));
        const backupData = {
          ...orderMetricDataFullState,
          manuallyAdded: 0,
          scannedProduct: 0,
          isMultipleBatch: false,
          avgProductAddTime: "",
          totalProducts: 0,
          productTimeArray: [],
          editOrderItem: 0,
          manuallyRemovedItems: 0,
          manualItemsGtin: [],
        };
        localStorage.setItem("orderMetricData", JSON.stringify(backupData));

        // Refresh cart data
        dataRetriveWhenPageRefresh(cartId)
          .then((res) => {
            syncCartDiscountState(res?.data?.data?.data);
            if (retailType === "RESTAURANT") {
              if (res?.data?.data?.data?.subOrderType === "QSR_DINE_IN") {
                setSaleMode("DINE_IN");
              } else {
                setSaleMode(res?.data?.data?.data?.subOrderType || "DINE_IN");
              }
            } else {
              setSaleMode(res?.data?.data?.data?.subOrderType || "DINE_IN");
            }
            setCartStatus(res?.data?.data?.data?.cartStatus);
            setContextCouponApplied?.(res?.data?.data?.data?.billing?.appliedCoupon || "0");
            syncCouponUiState(res?.data?.data?.data);
            setdeleteLoader(false);
            showSnackbar("Cart cleared successfully", "success");
            // QSR: re-open the customer panel once the cart is cleared
            if (retailType === "RESTAURANT" && branchSubType === "QSR") {
              setOpenCartCustomerDetail(true);
            }
            const currentStoreMode = localStorage.getItem("storeMode") || "ONLINE";
            localStorage.setItem("cartStoreMode", currentStoreMode);
          })
          .catch((err) => {
            showSnackbar(
              err?.response?.data?.message || err?.message || "Error refreshing cart",
              "error"
            );
            setdeleteLoader(false);
          });
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || err?.message || "Unable to clear cart",
          "error"
        );
        setdeleteLoader(false);
      });
  };

  const handleDiscountButton = () => {
    if (!cartItems || cartItems.length === 0) {
      showSnackbar("Please add items to the cart to apply discounts.", "info");
      return;
    }
    setDiscountDrawerOpen(true);
  };

  const { isLoyaltyEnabled, isCouponEnabled, disableLoyalty, disableCoupon } =
    useLoyaltyCouponConfig({
      isLoyaltyApplied: !!loyaltyPoints && showLoyalty,
      isCouponApplied: !!couponData?.couponValue && showCoupon,
    });

  const cartSidebarPresetType = useMemo(
    () => (branchSubType === "FINE_DINE" ? "RESTAURANT_CART_FINEDINE" : "RESTAURANT_CART_QSR"),
    [branchSubType]
  );

  const mobileCartSidebarHandlers = useMemo(
    () => ({
      customer: {
        onClick: handleNewCart,
        loading: customerLoader,
        customerAdded: !!customerMobile,
        customerName: customerName || customerMobile,
      },
      reprint: {
        onClick: () => handlePrintBill(false),
        loading: printBillLoader,
        visible: showFineDineActionButtons,
      },
      complimentary: {
        onClick: handleComplimentary,
        activated: complimentaryMode,
      },
      clearCart: {
        onClick: handleClearCart,
        loading: deleteLoader,
        visible: branchSubType === "FINE_DINE" ? saleMode !== "DINE_IN" : true,
        disabled: Array.isArray(cartItems) ? !(cartItems?.length >= 0) : true,
      },
      releaseTable: {
        onClick: () => handleTableActionButton("release"),
        loading: tableReleaseLoader,
        visible: saleMode === "DINE_IN",
      },
      transferTable: {
        onClick: () => handleTableActionButton("transfer"),
        visible: saleMode === "DINE_IN",
      },
      holdCart: {
        onClick: () => {
          if (cartItems.length < 1) {
            showSnackbar("Add products to the cart to hold.", "info");
          } else {
            setHoldCartModalOpen(true);
          }
        },
        visible: branchSubType === "FINE_DINE" ? saleMode !== "DINE_IN" : true,
      },
      addProduct: {
        onClick: onAddProductClick,
        visible: creationOfMenuEnabled,
      },
      discount: {
        disabled: !cartItems || cartItems.length === 0,
        onClick: handleDiscountButton,
      },
      coupon: {
        onClick: handleCouponModal,
        disabled: showFineDineActionButtons || disableCoupon,
      },
      offer: {
        onClick:
          retailType === "RESTAURANT"
            ? () => showSnackbar("Feature is coming soon", "warning")
            : handleOfferModalOpen,
        disabled: retailType === "RESTAURANT" || showFineDineActionButtons,
      },
      loyalty: {
        onClick: handleLoyaltyModal,
        disabled: showFineDineActionButtons || disableLoyalty,
      },
      paymentConfig: {
        onClick: handleManagerModalOpen,
      },
      note: {
        onClick: () => setNoteModalOpen(true),
        activated: !!comments,
      },
    }),
    [
      branchSubType,
      cartItems,
      comments,
      complimentaryMode,
      creationOfMenuEnabled,
      customerLoader,
      customerMobile,
      customerName,
      deleteLoader,
      onAddProductClick,
      printBillLoader,
      retailType,
      saleMode,
      showFineDineActionButtons,
      showSnackbar,
      tableReleaseLoader,
      isLoyaltyEnabled,
      isCouponEnabled,
      disableLoyalty,
      disableCoupon,
    ]
  );

  const desktopCartSidebarHandlers = useMemo(
    () => ({
      customer: {
        onClick: handleNewCart,
        loading: customerLoader,
        customerAdded: !!customerMobile,
        customerName: customerName || customerMobile,
      },
      reprint: {
        onClick: () => handlePrintBill(false),
        loading: printBillLoader,
        visible: showFineDineActionButtons,
      },
      complimentary: {
        onClick: handleComplimentary,
        activated: complimentaryMode,
      },
      clearCart: {
        onClick: handleClearCart,
        loading: deleteLoader,
        visible:
          branchSubType === "FINE_DINE"
            ? saleMode === "DELIVERY" || saleMode === "TAKE_AWAY"
            : true,
      },
      releaseTable: {
        onClick: () => handleTableActionButton("release"),
        loading: tableReleaseLoader,
        visible: saleMode === "DINE_IN",
      },
      transferTable: {
        onClick: () => handleTableActionButton("transfer"),
        visible: saleMode === "DINE_IN",
      },
      holdCart: {
        onClick: () => {
          if (cartItems.length < 1) {
            showSnackbar("Add products to the cart to hold.", "info");
          } else {
            setHoldCartModalOpen(true);
          }
        },
        visible: branchSubType === "FINE_DINE" ? saleMode !== "DINE_IN" : true,
      },
      addProduct: {
        onClick: onAddProductClick,
        visible: creationOfMenuEnabled,
      },
      discount: {
        disabled: showFineDineActionButtons || !cartItems || cartItems.length === 0,
        onClick: handleDiscountButton,
      },
      coupon: {
        onClick: handleCouponModal,
        disabled: showFineDineActionButtons || disableCoupon,
      },
      offer: {
        onClick:
          retailType === "RESTAURANT"
            ? () => showSnackbar("Feature is coming soon", "warning")
            : handleOfferModalOpen,
        disabled: retailType === "RESTAURANT" || showFineDineActionButtons,
      },
      loyalty: {
        onClick: handleLoyaltyModal,
        disabled: showFineDineActionButtons || disableLoyalty,
      },
      paymentConfig: {
        onClick: handleManagerModalOpen,
      },
      note: {
        onClick: () => setNoteModalOpen(true),
        activated: !!comments,
      },
    }),
    [
      branchSubType,
      cartItems,
      comments,
      complimentaryMode,
      creationOfMenuEnabled,
      customerLoader,
      customerMobile,
      customerName,
      deleteLoader,
      onAddProductClick,
      printBillLoader,
      retailType,
      saleMode,
      showFineDineActionButtons,
      showSnackbar,
      tableReleaseLoader,
      isLoyaltyEnabled,
      isCouponEnabled,
      disableLoyalty,
      disableCoupon,
    ]
  );

  return (
    <>
      {isExploding && (
        <div style={{ position: "relative" }} className="isExplodingDiv">
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "100%",
              height: "100%",
              zIndex: 9999,
            }}
          >
            <ConfettiExplosion {...confettiOptions} />
          </div>
        </div>
      )}

      <div className="rightContainer" ref={cartRightContainerRef} style={{ height: "100%" }}>
        {renderAuthModal()}
        <Modal
          open={openDelete}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title delete-text-theme" variant="h6" component="h2">
              Are you sure you want to delete all cart Items
            </Typography>

            <Box className="save-wrapper-box">
              <Button className="save-wrapper-btn" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button className="save-wrapper-btn" onClick={handleFlushClick}>
                {deleteLoader ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Delete"}
              </Button>
            </Box>
          </Box>
        </Modal>
        {offerCheckList.length === 0 ? null : (
          <Modal
            open={openOffer}
            onClose={handleCloseOfferModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                backgroundColor: color === "dark" ? "#353a50" : "#fff",
                color: color === "dark" ? "white" : "black",
                position: isMobile ? "static" : "relative",
                width: isMobile ? "100%" : "35%",
                maxWidth: "40vw",
                maxHeight: isMobile ? "100%" : "90%",
                transform: isMobile ? "none" : "translate(50%, -50%)",
                borderRadius: "10px",
                padding: "3vh",
                top: "50%",
                left: "10%",
                overflowY: "auto",
                ...(isMobile && {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }),
              }}
            >
              <Typography variant="h5">Available offers in your cart</Typography>
              {offerCheckList.map((e) => (
                <Card className="offer-avail-card">
                  <p style={{ fontWeight: "bold", paddingLeft: "20px", paddingTop: "20px" }}>
                    {e?.mainProductData?.mrp >= e?.mainProductData?.sellingPrice ? (
                      <b className="strike-off-mrp">&nbsp;{getStoreCurrencySymbol()}{e?.mainProductData?.mrp}&nbsp;</b>
                    ) : null}
                    <b>&nbsp;&nbsp;</b>{getStoreCurrencySymbol()}{e?.mainProductData?.sellingPrice}&nbsp;&nbsp; Buy{" "}
                    {e?.mainProductData?.buyQuantity} Get {e?.offerProductData?.getQuantity} free
                  </p>
                  <div className="available-offer-box">
                    <div>
                      <label>
                        <p className="select-item-details">
                          Product : {e?.mainProductData?.productName}{" "}
                        </p>
                        <p className="select-item-details">Gtin : {e?.mainProductData?.gtin} </p>
                        <p className="select-item-details">
                          Batch : {e?.mainProductData?.batchNo}{" "}
                        </p>
                      </label>
                    </div>
                    <div>
                      <label>
                        <p className="select-item-details">
                          Offer Product : {e?.offerProductData?.productName}{" "}
                        </p>
                        <p className="select-item-details">Gtin : {e?.mainProductData?.gtin} </p>
                        <p className="select-item-details">
                          Batch : {e?.mainProductData?.batchNo}{" "}
                        </p>
                      </label>
                    </div>
                  </div>
                </Card>
              ))}
            </Box>
          </Modal>
        )}

        {/* <div className="cart-type-strip">
          {isSalesOrder && CartId ? (
            <>
              <span className="cart-type-pill cart-type-pill--b2b">B2B</span>
              <span className="cart-type-label">
                {localStorage.getItem("b2bPartnerName") || "Sales Order"}
              </span>
            </>
          ) : (
            <span className="cart-type-pill cart-type-pill--b2c">B2C</span>
          )}
        </div> */}
        <div className="cartAndSidebarContainer">
          <div
            className={"emptyCartContainer"}
            id="scrollTopDiv"
            ref={thirdrefElement}
            tabIndex="1"
            style={{ marginTop: isMobile ? "2rem" : "0" }}
          >
            <CartCustomerDetails
              open={openCartCustomerDetail}
              cartItems={cartItems}
              setCartItems={setCartItems}
              setOpenCartCustomerDetail={setOpenCartCustomerDetail}
              setName={setCustomerName}
              setCustomerLoader={setCustomerLoader}
              slotDetails={slotDetails}
              setSlotDetails={setSlotDetails}
              deliveryCharge={deliveryCharge}
              setDeliveryCharge={setDeliveryCharge}
              packingCharge={packingCharge}
              setPackingCharge={setPackingCharge}
              deliveryChargesLoader={deliveryChargesLoader}
              setDeliveryChargesLoader={setDeliveryChargesLoader}
              packingChargesLoader={packingChargesLoader}
              setPackingChargesLoader={setPackingChargesLoader}
            />

            {!openCartCustomerDetail && branchSubType === "QSR" && (
              <div className="qsrSaleModeContainer">
                <div className="qsrSaleModeButtons">
                  {["DINE_IN", "TAKE_AWAY", "DELIVERY"].map((mode) => (
                    <button
                      key={mode}
                      type="button"
                      className={`qsrSaleModeBtn ${saleMode === mode ? "active" : ""}`}
                      onClick={() => handleOptionChange({ target: { value: mode } })}
                    >
                      {mode === "DINE_IN"
                        ? "Dine In"
                        : mode === "DELIVERY"
                        ? "Delivery"
                        : "Takeaway"}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {!openCartCustomerDetail && branchSubType === "FINE_DINE" && (
              <>
                {/* Sale mode switcher */}
                <div className="qsrSaleModeContainer">
                  <div className="qsrSaleModeButtons">
                    {["DINE_IN", "TAKE_AWAY", "DELIVERY"].map((mode) => (
                      <button
                        key={mode}
                        type="button"
                        className={`qsrSaleModeBtn ${saleMode === mode ? "active" : ""}`}
                        onClick={() => handleFineDineSaleModeChange(mode)}
                      >
                        {mode === "DINE_IN"
                          ? "Dine In"
                          : mode === "DELIVERY"
                          ? "Delivery"
                          : "Takeaway"}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Container 2: Table info + KOTs */}
                <div className="cartTableInfoContainer">
                  <div className="tableNumberContainerIcon">
                    {selectedTable && saleMode === "DINE_IN" ? (
                      <div className="table-layout-display">
                        <p className="cartTableName">Table: {selectedTable?.tableNoForDisplay}</p>
                        <p className="cart-table-layout-display">
                          {selectedTable?.layoutName}. Dine In
                        </p>
                      </div>
                    ) : saleMode === "TAKE_AWAY" ? (
                      <div className="cart-order-type-card">
                        <div className="cart-order-type-left">
                          <span className="cart-order-type-label">ORDER TYPE</span>
                          <span className="cart-order-type-title">Takeaway</span>
                          <span className="cart-order-type-sub">
                            No table mapping required for this order.
                          </span>
                        </div>
                        <span className="cart-order-type-badge">
                          <span className="cart-order-type-dot" />
                          Active
                        </span>
                      </div>
                    ) : (
                      <div className="cart-order-type-card">
                        <div className="cart-order-type-left">
                          <span className="cart-order-type-label">ORDER TYPE</span>
                          <span className="cart-order-type-title">Delivery</span>
                          <span className="cart-order-type-sub">
                            No table mapping required for this order.
                          </span>
                        </div>
                        <span className="cart-order-type-badge">
                          <span className="cart-order-type-dot" />
                          Active
                        </span>
                      </div>
                    )}
                  </div>
                  {retailType === "RESTAURANT" && saleMode === "DINE_IN" && !complimentaryMode && (
                    <div
                      className="kotText"
                      onClick={() => setAllKotsModalOpen(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                        <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path>
                        <rect x="6" y="14" width="12" height="8" rx="1"></rect>
                      </svg>
                      <div className="kotTextInner">
                        <p className="kotTextLabel">{getTotalKOTs().label} › </p>
                        {getTotalKOTs().amount > 0 && (
                          <p className="kotTextAmount">
                            {getStoreCurrencySymbol()}{getTotalKOTs().amount.toFixed(2).replace(/\.00$/, "")}
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flex: 1,
                minHeight: 0,
                minWidth: 0,
                overflow: "hidden",
                paddingBottom: "60px",
              }}
            >
              {cartItems !== null && cartItems?.length > 0 ? (
                <>
                  {!openCartCustomerDetail && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minHeight: 0,
                        minWidth: 0,
                        overflow: "hidden",
                        position: "relative",
                      }}
                    >
                      <div className="cartProductsList" ref={cartListRef} onScroll={handleScroll}>
                        {lastAddedTime &&
                          saleMode !== "DELIVERY" &&
                          saleMode !== "TAKE_AWAY" &&
                          saleMode !== "QSR_DINE_IN" && (
                            <div className="cartNewOrderHeader">
                              <span className="cartNewOrderLabel">New Order: {lastAddedTime}</span>
                              <span className="cartNewOrderTime">
                                <ChevronDownIcon />
                              </span>
                            </div>
                          )}
                        {!openCartCustomerDetail &&
                          saleMode !== "DELIVERY" &&
                          saleMode !== "TAKE_AWAY" &&
                          saleMode !== "QSR_DINE_IN" &&
                          (branchSubType === "FINE_DINE" ? (
                            <>
                              {saleMode !== "DINE_IN" && (
                                <div className="cartInformationText">
                                  <p className="cartDetailsItemNo">
                                    Items: {cartItems?.length || 0}, Quantity:{" "}
                                    {cartItems?.reduce(
                                      (total, item) => total + (item?.quantity || 0),
                                      0
                                    ) || 0}
                                  </p>
                                </div>
                              )}
                            </>
                          ) : (
                            <></>
                          ))}
                        {retailType === "RESTAURANT" && complimentaryMode ? (
                          <ComplimentaryProductList
                            products={complimentaryProductList}
                            selectedIds={selectedComplimentaryIds}
                            setSelectedIds={setSelectedComplimentaryIds}
                            getTotalKOTs={getTotalKOTs}
                            complimentaryProductPayload={complimentaryProductPayload}
                            setComplimentaryProductPayload={setComplimentaryProductPayload}
                            markWholeCartComplimentary={markWholeCartComplimentary}
                          />
                        ) : (
                          <>
                            {retailType !== "RESTAURANT" ? (
                              cartItems?.map((ele, index) => {
                                return (
                                  <CartItem
                                    key={`item-${ele?.cartProductId}-${index}`}
                                    ele={ele}
                                    index={index}
                                    decreaseItemQuantity={decreaseItemQuantity}
                                    increaseItemQuantity={increaseItemQuantity}
                                    increaseCartItemLoader={increaseCartItemLoader}
                                    animationBox={animationBox}
                                    gtinItem={gtinItem}
                                    highlightMrp={highlightMrp}
                                    setDisableProceed={setDisableProceed}
                                    setShowFineDineActionButtons={setShowFineDineActionButtons}
                                    setHasRequestedForNewItem={setHasRequestedForNewItem}
                                    isHighlighted={highlightedCartProductId === ele?.cartProductId}
                                  />
                                );
                              })
                            ) : retailType === "RESTAURANT" &&
                              saleMode === "DINE_IN" &&
                              branchSubType === "FINE_DINE" ? (
                              <>
                                {isOn ? (
                                  <>
                                    <hr className="aggCartViewDivider" />
                                    <div className="aggCartProductsContainer">
                                      {aggregatedCartProducts.map((item, idx) => (
                                        <div key={idx} className="aggCartProductsWrapper">
                                          <CartAggsLayout
                                            foodType={item?.foodType}
                                            productName={`${item?.productName} (${item?.variantName})`}
                                            quantity={item?.quantity}
                                            price={item?.subTotalWithoutTax}
                                            addonProduct={item?.addonProduct}
                                            isReturned={item?.isReturned}
                                            isComplimentary={item?.isComplimentary}
                                            isBundle={item?.isBundle}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {groupedCartItems
                                      ?.filter((g) => g?.sequence === null)
                                      ?.flatMap((group) => group?.items || [])
                                      ?.map((ele, itemIndex, allItems) => {
                                        return (
                                          <React.Fragment
                                            key={`item-${ele?.cartProductId}-${itemIndex}`}
                                          >
                                            <div
                                              ref={
                                                cartItems?.[focusedCartItemIndex]?.cartProductId ===
                                                ele?.cartProductId
                                                  ? focusedCartItemRef
                                                  : null
                                              }
                                            >
                                              <CartItem
                                                ele={ele}
                                                index={itemIndex}
                                                decreaseItemQuantity={decreaseItemQuantity}
                                                increaseItemQuantity={increaseItemQuantity}
                                                increaseCartItemLoader={increaseCartItemLoader}
                                                animationBox={animationBox}
                                                gtinItem={gtinItem}
                                                highlightMrp={highlightMrp}
                                                setDisableProceed={setDisableProceed}
                                                setShowFineDineActionButtons={
                                                  setShowFineDineActionButtons
                                                }
                                                setHasRequestedForNewItem={
                                                  setHasRequestedForNewItem
                                                }
                                                isHighlighted={
                                                  highlightedCartProductId === ele?.cartProductId
                                                }
                                                isKeyboardFocused={
                                                  cartItems?.[focusedCartItemIndex]
                                                    ?.cartProductId === ele?.cartProductId
                                                }
                                              />
                                            </div>
                                            {itemIndex < allItems?.length - 1 && (
                                              <hr className="cartItemDivider" />
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {cartItems?.map((ele, index) => {
                                  return (
                                    <div
                                      key={index}
                                      ref={
                                        focusedCartItemIndex === index ? focusedCartItemRef : null
                                      }
                                    >
                                      <CartItem
                                        ele={ele}
                                        index={index}
                                        decreaseItemQuantity={decreaseItemQuantity}
                                        increaseItemQuantity={increaseItemQuantity}
                                        increaseCartItemLoader={increaseCartItemLoader}
                                        animationBox={animationBox}
                                        gtinItem={gtinItem}
                                        highlightMrp={highlightMrp}
                                        setDisableProceed={setDisableProceed}
                                        setShowFineDineActionButtons={setShowFineDineActionButtons}
                                        setHasRequestedForNewItem={setHasRequestedForNewItem}
                                        isHighlighted={
                                          highlightedCartProductId === ele?.cartProductId
                                        }
                                        isKeyboardFocused={focusedCartItemIndex === index}
                                      />
                                    </div>
                                  );
                                })}
                              </>
                            )}
                            {!openCartCustomerDetail && (
                              <div className="cartBottomSectionWrapper">
                                {!openCartCustomerDetail &&
                                  (branchSubType === "FINE_DINE" ? (
                                    <>
                                      <div className="bottomCouponSectionWrapper">
                                        {showCoupon && couponData?.couponValue && (
                                          <div>
                                            <CouponUI data={couponData} />
                                          </div>
                                        )}
                                        {appliedDiscountAmt > 0 && (
                                          <div>
                                            <AppliedDiscountCard
                                              amount={appliedDiscountAmt}
                                              discountType={appliedDiscountType}
                                              onRemove={handleRemoveDiscount}
                                              loading={discountApplyLoader}
                                            />
                                          </div>
                                        )}
                                        {loyaltyPoints && showLoyalty && (
                                          <div>
                                            <LoyaltyAppliedUI
                                              data={loyaltyPoints}
                                              handleOpenloyalty={handleLoyaltyModal}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="bottomCouponSectionWrapper">
                                        {showCoupon && couponData?.couponValue && (
                                          <div>
                                            <CouponUI data={couponData} />
                                          </div>
                                        )}
                                        {appliedDiscountAmt > 0 && (
                                          <div>
                                            <AppliedDiscountCard
                                              amount={appliedDiscountAmt}
                                              discountType={appliedDiscountType}
                                              onRemove={handleRemoveDiscount}
                                              loading={discountApplyLoader}
                                            />
                                          </div>
                                        )}
                                        {loyaltyPoints && showLoyalty && (
                                          <div>
                                            <LoyaltyAppliedUI
                                              data={loyaltyPoints}
                                              handleOpenloyalty={handleLoyaltyModal}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {!openCartCustomerDetail && (
                    <div className="noItemCart">
                      <div className="empty-cart-state">
                        <div className="empty-cart-icon-wrap">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#3b82f6"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M17 8h1a4 4 0 1 1 0 8h-1" />
                            <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" />
                            <line x1="6" y1="2" x2="6" y2="4" />
                            <line x1="10" y1="2" x2="10" y2="4" />
                            <line x1="14" y1="2" x2="14" y2="4" />
                          </svg>
                        </div>
                        <p className="empty-cart-title">Start a fresh order</p>
                        <p className="empty-cart-sub">
                          This table is ready for its first item. Pick dishes from the menu on the
                          left to begin building the cart.
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
              {!openCartCustomerDetail &&
                typeof document !== "undefined" &&
                document.getElementById("cart-gross-bar-portal") &&
                createPortal(
                  (() => {
                    const isCartEmpty = !cartItems?.length;
                    return (
                      <div className="cartGrossAndActionRow">
                        <div className="cartGrossTotalInfo">
                          <button
                            type="button"
                            className="cart-kitchen-note-btn"
                            onClick={() => setNoteModalOpen(true)}
                            title="Order notes to kitchen"
                            disabled={isCartEmpty}
                            data-testid="button-open-order-kitchen-note"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-file-text h-5 w-5 stroke-[2.5px]"
                              aria-hidden="true"
                            >
                              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                              <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                              <path d="M10 9H8" />
                              <path d="M16 13H8" />
                              <path d="M16 17H8" />
                            </svg>
                          </button>
                          <div className="cart-gross-total-column">
                            <span className="cart-gross-total-label-new">Gross Total</span>
                            <span
                              className="cart-gross-amount-new"
                              data-testid="text-cart-footer-total"
                            >
                              {getStoreCurrencySymbol()}{total || "0.00"}
                            </span>
                          </div>
                        </div>
                        <div className="cartGrossActionButtons">
                          {/* {offerFound ? ( */}
                          {!complimentaryMode && cartItems?.some((p) => p?.isOfferAvailable && !p?.offerApplied) ? (
                            <button
                              type="button"
                              className="cart-btn-primary"
                              onClick={handleOfferCalculate}
                              disabled={isCartEmpty || offerLoader}
                            >
                              {offerLoader ? (
                                <CircularProgress size={20} color="inherit" />
                              ) : (
                                <div className="offer-btn-cart">
                                  <b className="total-text-box">(F1)</b>
                                  <div className="number-text">Apply Offer </div>{" "}
                                  <LocalOfferIcon className="number-icon" fontSize="medium" />
                                </div>
                              )}
                            </button>
                          ) : (
                            <>
                              {branchSubType === "FINE_DINE" && saleMode === "DINE_IN" ? (
                                <FineDineActionButtons
                                  hasRequestedForNewItem={hasRequestedForNewItem}
                                  showFineDineActionButtons={showFineDineActionButtons}
                                  complimentaryMode={complimentaryMode}
                                  disableProceed={isCartEmpty || disableProceed}
                                  noteFromCustLoader={noteFromCustLoader}
                                  kotPrintMode={kotPrintMode}
                                  billPrintMode={billPrintMode}
                                  placeOrderLoader={placeOrderLoader}
                                  printBillLoader={printBillLoader}
                                  complementaryButtonLoader={complementaryButtonLoader}
                                  selectedComplimentaryIds={selectedComplimentaryIds}
                                  markWholeCartComplimentary={markWholeCartComplimentary}
                                  isMobile={isMobile}
                                  isBillPrinted={isBillPrinted}
                                  printedBillOrderId={printedBillOrderId}
                                  handleTableReservation={handleTableReservation}
                                  handlePrintBill={handlePrintBill}
                                  handleOpenPaymentModal={handleOpenPaymentModal}
                                  handleComplimentaryCancel={handleComplimentaryCancel}
                                  handleComplimentaryApi={handleComplimentaryApi}
                                />
                              ) : (
                                <div className="checkoutButton">
                                  {complimentaryMode ? (
                                    <div className="complimentaryModeActionButton">
                                      <button
                                        type="button"
                                        className="cart-btn-outline"
                                        style={{ width: "50%" }}
                                        onClick={handleComplimentaryCancel}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        className="cart-btn-primary"
                                        style={{ width: "100%" }}
                                        disabled={
                                          isCartEmpty ||
                                          (selectedComplimentaryIds?.length === 0 &&
                                            !markWholeCartComplimentary) ||
                                          complementaryButtonLoader
                                        }
                                        onClick={handleComplimentaryApi}
                                      >
                                        {complementaryButtonLoader ? (
                                          <CircularProgress size={20} color="inherit" />
                                        ) : (
                                          <>
                                            <span>Add As Complimentary</span>
                                            <GiftIcon
                                              style={{
                                                marginLeft: "8px",
                                                width: "16px",
                                                height: "16px",
                                              }}
                                            />
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      type="button"
                                      className="cart-btn-primary"
                                      style={{ width: "100%" }}
                                      onClick={handleProceed}
                                      disabled={isCartEmpty || disableProceed || noteFromCustLoader}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-credit-card mr-2 h-4.5 w-4.5"
                                        aria-hidden="true"
                                        style={{ marginRight: "8px" }}
                                      >
                                        <rect width="20" height="14" x="2" y="5" rx="2" />
                                        <line x1="2" x2="22" y1="10" y2="10" />
                                      </svg>
                                      Proceed to pay {getStoreCurrencySymbol()}{total || "0.00"}
                                    </button>
                                  )}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })(),
                  document.getElementById("cart-gross-bar-portal")
                )}
              {!isMobile && (
                <div
                  className="cartRightSidebarContainer"
                  style={{
                    height: "100%",
                  }}
                >
                  <CartRightSidebar
                    presetType={cartSidebarPresetType}
                    buttonHandlers={desktopCartSidebarHandlers}
                  />
                </div>
              )}
            </div>
          </div>
          {isMobile && !showCartOptions && (
            <div className="mobileFloatingOptsContainer">
              <PosCustomButton
                title="Options"
                variant="black-d"
                radius="50px"
                p="10px 14px"
                onClickFunction={() => setShowCartOptions(true)}
                fontSize="1rem"
              />
            </div>
          )}
          {isMobile && (
            <div
              className={`mobileOptionsBackdrop ${showCartOptions ? "show" : ""}`}
              onClick={() => setShowCartOptions(false)}
            >
              <div className={`mobileOptionsSheet ${showCartOptions ? "open" : ""}`}>
                <div className="sheetHeader">
                  <PosCustomIcon
                    icon={<XMarkIcon />}
                    height={"16px"}
                    width={"16px"}
                    color="--var(surface-black)"
                    onClickFunction={() => setShowCartOptions(false)}
                    pointer={true}
                  />
                </div>

                <div className="sheetContent">
                  <CartRightSidebar
                    presetType={cartSidebarPresetType}
                    buttonHandlers={mobileCartSidebarHandlers}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Note from customer modal */}
        {noteModalOpen && (
          <div className="onm-overlay" onClick={() => setNoteModalOpen(false)}>
            <div className="onm-modal" onClick={(e) => e.stopPropagation()}>
              {/* Header */}
              <div className="onm-header">
                <span className="onm-title">ORDER NOTES TO KITCHEN</span>
                <span className="onm-optional-badge">Optional</span>
              </div>
              <p className="onm-subtitle">
                Add instructions for the full order. These print alongside any item-level notes.
              </p>

              {/* Textarea */}
              <div className="onm-textarea-wrap">
                <textarea
                  className="onm-textarea"
                  placeholder="Example: Fire all starters first, keep mains after 10 mins, no peanuts anywhere in this order"
                  value={comments}
                  onChange={handleComments}
                  autoFocus
                  rows={5}
                />
                {noteFromCustLoader && (
                  <div className="onm-loader">
                    <CircularProgress size={16} sx={{ color: "#5271ff" }} />
                  </div>
                )}
              </div>

              {/* Char counter pill */}
              <div className="onm-char-row">
                <span className="onm-char-hint">
                  {comments?.length > 0 ? comments : "No order-level kitchen note added yet."}
                </span>
                <span className="onm-char-count">{comments?.length || 0} CHARS</span>
              </div>

              {/* Footer */}
              <div className="onm-footer">
                <button
                  className="onm-btn onm-btn-clear"
                  onClick={() => {
                    handleComments({ target: { value: "" } });
                  }}
                >
                  Clear
                </button>
                <button
                  className="onm-btn onm-btn-done"
                  onClick={() => setNoteModalOpen(false)}
                  disabled={noteFromCustLoader}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        )}

        <OfferListing offerModal={offerModal} handleOfferModalClose={handleOfferModalClose} />
        <OfferCheckModal
          offerCheckModal={offerCheckModal}
          handleCloseOfferCheckModal={handleCloseOfferCheckModal}
          setOfferFound={setOfferFound}
          offerListData={offerListData}
          showOffer={showOffer}
        />
        <DeliveryModal
          handleCloseDeliveryPopUp={handleCloseDeliveryPopUp}
          openDelivery={openDelivery}
        />
        <LoyaltyPopupCustom
          setShowLoyalty={setShowLoyalty}
          loyaltyModal={loyaltyModal}
          handleCloseModal={handleCloseModalLoyalty}
          setLoyaltyModal={setLoyaltyModal}
          setOpen={setOpen}
          setOpenCartCustomerDetail={setOpenCartCustomerDetail}
          type="RESTAURANT"
        />
        <CouponPopup
          type={"RESTAURANT"}
          couponsModal={couponsModal}
          setCouponsModal={setCouponsModal}
          setShowCoupon={setShowCoupon}
        />
        <PaymentModal
          variant="restaurant"
          saleMode={saleMode}
          cartId={CartId}
          setPackingCharge={setPackingCharge}
          setDeliveryCharge={setDeliveryCharge}
          setPartailStatus={setPartailStatus}
          canceledOnce={canceledOnce}
          openPayModal={openPayModal}
          closePaymentModal={closePaymentModal}
          cartItems={cartItems}
          newLoader={newLoader}
          modalLoader={modalLoader}
          payLoader={payLoader}
          handleOpenPaymentModal={handleOpenPaymentModal}
          partialStatus={partialStatus}
          paymentMethod={paymentMethod}
          adjustCheck={adjustCheck}
          amtToBePaid={amtToBePaid}
          setPaymentMethod={setPaymentMethod}
          cashIcon={cashNew}
          cashIconSelected={cashNewSelected}
          upiIcon={upiNew}
          upiIconSelected={upiNewSelected}
          cardIcon={cardNew}
          cardIconSelected={cardNewSelected}
          creditIcon={creditNew}
          creditIconSelected={creditNewSelected}
          storeMode={storeMode}
          handleOffline={handleOffline}
          singleOrderoffline={singleOrderoffline}
          offlineImg={offlineImg}
          splitActive={splitActive}
          setSplitActive={setSplitActive}
          splitImg={splitNew}
          splitImgSelected={splitNewSelected}
          handleSplitPayment={handleSplitPayment}
          clrAmountFun={clrAmountFun}
          enterAmount={enterAmount}
          setEnterAmount={setEnterAmount}
          enterAmountRef={enterAmountRef}
          setAmtFocus={setAmtFocus}
          total={total}
          orderSummary={paymentOrderSummary}
          amtHeading={amtHeading}
          amountDue={amountDue}
          appliedDiscountAmt={appliedDiscountAmt}
          appliedDiscountType={appliedDiscountType}
          cashChange={cashChange}
          handlesplitInputChange={handlesplitInputChange}
          partialCompletePayment={partialCompletePayment}
          checkPayment={checkPayment}
          amountPaid={amountPaid}
          functionCalled={functionCalled}
          createOrderFun={createOrderFun}
          setFunctionCalled={setFunctionCalled}
          cardFunctionCalled={cardFunctionCalled}
          digitalPaymentFunUPI={digitalPaymentFunUPI}
          setCardFunctionCalled={setCardFunctionCalled}
          setSplitFunctionCalled={setSplitFunctionCalled}
          splitFunctionCalled={splitFunctionCalled}
          paymentLoader={paymentLoader}
          paymentLoadingModal={paymentLoadingModal}
          manual={manual}
          transCode={transCode}
          approveloader={approveloader}
          handleManualorders={handleManualorders}
          cashierPin={cashierPin}
          paymentFailed={paymentFailed}
          newId={newId}
          failedImgWarning={failedImgWarning}
          handleTansactionCancel={handleTansactionCancel}
          cancelLoader={cancelLoader}
          paymentSuccess={paymentSuccess}
          isError={isError}
          isPrinting={isPrinting}
          orderId={orderId}
          resetValues={resetValues}
          paymentCancel={paymentCancel}
          cancelGif={cancelGif}
          handleManual={handleManual}
          newTransId={newTransId}
          setOpen={setOpen}
          setPaymentSuccess={setPaymentSuccess}
          setpaymentLoader={setpaymentLoader}
          handleOptionChange={handleOptionChange}
          setOpenCartCustomerDetail={setOpenCartCustomerDetail}
          setShowFineDineActionButtons={setShowFineDineActionButtons}
          billPrintMode={billPrintMode}
          kotPrintMode={kotPrintMode}
          isBillPrinted={isBillPrinted}
          printedBillOrderId={printedBillOrderId}
          hideSplitPayment={false}
        />
      </div>
      <ReleaseTableDrawer
        open={tableConfirmationModalOpen}
        onClose={() => setTableConfirmationModalOpen(false)}
        tableName={selectedTable?.tableNoForDisplay || selectedTable?.tableMetadata?.tableName}
        loading={tableReleaseLoader}
        onConfirm={() => {
          handleTableRelease("release");
          setTableConfirmationModalOpen(false);
        }}
      />
      <TransferTableModal
        open={transferTableModalOpen}
        onClose={() => setTransferTableModalOpen(false)}
        currentTable={selectedTable}
        onSuccess={({ tableName, tableId }) => {
          setSelectedTable((prev) => ({
            ...prev,
            tableNoForDisplay: tableName,
            tableMetadata: {
              ...prev?.tableMetadata,
              tableName,
              tableMetadataId: tableId,
            },
          }));
          setTableSelectionModalOpen(true);
        }}
      />
      <ManagerAuthModal
        managerModal={managerModal}
        storeMode={storeMode}
        setmanagerModal={setmanagerModal}
        handleManagerModalClose={handleManagerModalClose}
        machinenewId={machinenewId}
      />
      <AllKotsModal
        open={allKotsModalOpen}
        onClose={() => setAllKotsModalOpen(false)}
        groupedCartItems={groupedCartItems}
        cartId={CartId}
        orgId={orgId}
        locId={locId}
        generatedBy={retailUserLocalStorageData?.uidx}
        generatedByName={retailUserLocalStorageData?.firstName}
        printToken={printToken}
        customerName={customerName}
        setShowFineDineActionButtons={setShowFineDineActionButtons}
        setHasRequestedForNewItem={setHasRequestedForNewItem}
        onComplimentary={handleItemComplimentary}
        onCartUpdated={syncCartDiscountState}
        onItemServed={(servedProduct) => {
          setCartItems((current) => current?.map((product) =>
            product?.cartProductId === servedProduct?.cartProductId && product?.productStatus !== "RETURNED"
              ? { ...product, productStatus: servedProduct?.productStatus } : product
          ));
        }}
        complementaryButtonLoader={complementaryButtonLoader}
        onRepeatOrder={handleRepeatOrderFromKot}
      />
      <DiscountDrawer
        open={discountDrawerOpen}
        onClose={() => setDiscountDrawerOpen(false)}
        onApply={handleApplyDiscount}
        onRemove={handleRemoveDiscount}
        appliedDiscountAmt={appliedDiscountAmt}
        appliedDiscountType={appliedDiscountType}
        isApplying={discountApplyLoader}
        cartTotal={total}
      />
      <HoldCartModal
        open={holdCartModalOpen}
        onClose={() => setHoldCartModalOpen(false)}
        cartId={cartId}
        cartItems={cartItems}
        total={total}
        onViewHeldOrders={() => setHoldOrderDrawerOpen(true)}
        onHoldSuccess={(res) => {
          if (res?.data?.status === "SUCCESS") {
            dispatch(setHoldOrdersCount(holdOrdersCount + 1));
          }
          localStorage.setItem("orderMetricData", JSON.stringify({}));
          localStorage.removeItem("CartId");
          setOpenCartCustomerDetail(true);
          setTimeout(() => {
            navigate("/restaurant/cart");
          }, 500);
        }}
      />
      <HoldOrderDrawer open={holdOrderDrawerOpen} onClose={() => setHoldOrderDrawerOpen(false)} />
    </>
  );
}
